/**
 * KOMBINIERTE TRACKING-DATEI (Stand 10.9.26 — v5: alle Besucher, Produktseiten-Konfigurator, Formular-Tiefe, Herkunft)
 * Block 1 = Attribution: Klick-IDs/UTMs erfassen + Besucher-Key + Calendly-Dekoration (inkl. v:<vid>)
 *           + zentraler /api/beratung-Fetch-Interceptor
 * Block 2 = Contact-Form-Hook (dedupliziert, single-fire)
 * Block 3 = Engagement-Beacon (Ad-Quality) inkl. Konfigurator-Tiefe + Pixel-Spiegelung
 *           + Besuchs-Kontobuch eh_journey / Muster A → EDELHOLZ_HotProspect (23.9.26)
 *           + Identitaets-Bruecken: mailto-Betreff [J-<vid>], tel-Klick-Beacon (23.9.26 abends)
 *           + Browser-Zwilling EDELHOLZ_EngagedVisit v2 (27.9.26)
 * Block 4 = Cookie-Banner im Stil des EDELHOLZ-Dialog-Systems
 * In EINER Datei, weil edelholz-contact-hook.js bereits im theme.liquid-Head
 * eingebunden ist — so braucht es keine Layout-Aenderung.
 */
(function () {
  if (window.EdelholzAttribution) return;
  var KEY = 'eh_attr_v1';
  var MAX_AGE_MS = 90 * 24 * 3600 * 1000; // 90 Tage

  function readStore() {
    try {
      var d = JSON.parse(localStorage.getItem(KEY) || 'null');
      if (!d || !d.t || (Date.now() - d.t) > MAX_AGE_MS) return null;
      return d;
    } catch (e) { return null; }
  }
  function writeStore(d) {
    try { localStorage.setItem(KEY, JSON.stringify(d)); } catch (e) {}
  }
  function getCookie(name) {
    var m = document.cookie.match('(^|;)\\s*' + name + '=([^;]+)');
    return m ? decodeURIComponent(m[2]) : '';
  }

  // --- Besucher-Key ---
  // sid (sessionStorage) endet mit dem Tab. Fuer "wie viele Besuche hatte ein
  // spaeterer Kaeufer" braucht es einen Key, der Besuche ueberdauert: vid.
  // Wird IMMER gesetzt (auch ohne Ad-Klick) — Kunden kommen oft erst ueber eine
  // Anzeige und spaeter direkt zurueck; sonst reisst die Kette genau dort.
  // 23.9.26 (Datenschutz, Entscheidung Philipp): Ablauf ohne Besuch; 24.9.26 auf 365 Tage gesetzt.
  // Gespeichert als JSON { v: vid, t: letzter Besuch (ms) }; jeder Seitenaufruf
  // setzt t neu. Aeltere Klartext-Werte (vor 23.9.26) werden uebernommen und mit
  // t = jetzt migriert. Die Attribution (Klick-IDs, MAX_AGE_MS) bleibt bei 90 Tagen.
  var VID_KEY = 'eh_vid', VID_MAX_AGE_MS = 365 * 24 * 3600 * 1000; // 365 Tage
  // 24.9.26: Safari loescht per Skript angelegten localStorage nach 7 Tagen (ITP).
  // Deshalb lebt die vid zusaetzlich im Cookie eh_vid (Domain .edelholz-manufaktur.de),
  // das der Server mit jeder Beacon-Antwort auf 365 Tage erneuert (Server-Cookies
  // sind von der 7-Tage-Grenze ausgenommen). Vorrang: Cookie > localStorage > neu.
  // Der Client spiegelt das Cookie sofort, damit es schon vor der ersten Antwort da ist.
  function vidCookieLesen() {
    try {
      var m = document.cookie.match(/(?:^|;\s*)eh_vid=([^;]*)/);
      var c = m ? decodeURIComponent(m[1]) : '';
      return /^[a-z0-9]{6,40}$/i.test(c) ? c : '';
    } catch (e) { return ''; }
  }
  function vidCookieSetzen(v) {
    try {
      var dom = /(^|\.)edelholz-manufaktur\.de$/.test(location.hostname) ? '; domain=.edelholz-manufaktur.de' : '';
      document.cookie = 'eh_vid=' + encodeURIComponent(v) + '; max-age=31536000' + dom + '; path=/; secure; samesite=lax';
    } catch (e) {}
  }
  var vid = vidCookieLesen();
  try {
    var vRoh = vid ? '' : (localStorage.getItem(VID_KEY) || ''), vObj = null;
    if (vRoh.charAt(0) === '{') {
      try { vObj = JSON.parse(vRoh); } catch (e) { vObj = null; }
      if (vObj && typeof vObj === 'object' && typeof vObj.v === 'string' && vObj.v &&
          (+vObj.t || 0) > 0 && (Date.now() - (+vObj.t)) <= VID_MAX_AGE_MS) vid = vObj.v;
    } else if (vRoh) {
      vid = vRoh; // Migration: Klartext-vid behalten, Ablauf-Uhr startet jetzt
    }
    if (!vid) vid = 'v' + Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
    localStorage.setItem(VID_KEY, JSON.stringify({ v: vid, t: Date.now() }));
  } catch (e) {}
  if (vid) vidCookieSetzen(vid);
  var sid = '';
  try {
    sid = sessionStorage.getItem('eh_sid') || '';
    if (!sid) { sid = 's' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8); sessionStorage.setItem('eh_sid', sid); }
  } catch (e) { sid = 's0' + Math.random().toString(36).slice(2, 8); } // randomisiert — sonst verschmelzen alle Storage-Blocker zu EINER Session
  if (!vid) vid = sid;   // Safari Privat: Besucher-Key haelt wenigstens die Sitzung
  // 10.9.26: Einstiegsseite + Referrer-Host der Sitzung (fuer Vorher/Nachher-Auswertung, alle Besucher)
  var landing = '', refHost = '';
  try {
    landing = sessionStorage.getItem('eh_land') || '';
    if (!landing) { landing = location.pathname; sessionStorage.setItem('eh_land', landing); }
    refHost = sessionStorage.getItem('eh_ref') || '';
    if (!refHost && !sessionStorage.getItem('eh_ref_set')) {
      try { var rh = document.referrer ? new URL(document.referrer).hostname : ''; if (rh && rh.indexOf('edelholz') === -1) refHost = rh.replace(/^(www|m|l|lm)\./, ''); } catch (e) {}
      sessionStorage.setItem('eh_ref', refHost); sessionStorage.setItem('eh_ref_set', '1');
    }
  } catch (e) {}

  // --- Beim Laden: URL-Parameter einsammeln ---
  var params;
  try { params = new URLSearchParams(window.location.search); } catch (e) { params = null; }
  var store = readStore() || { t: Date.now(), first: null, last: null };
  if (params) {
    var touch = {};
    var found = false;
    // gbraid/wbraid = Googles Klick-IDs bei eingeschraenkten Cookies (iOS).
    // tw_campaign/tw_adid liefert das bestehende Google-Tracking-Template und
    // enthaelt die ECHTE Kampagnen-/Anzeigen-ID — der exakte Schluessel, um
    // bezahlte Google-Klicks dem Website-Verhalten zuzuordnen.
    // h_ad_id/fbc_id = Meta-URL-Template (h_ad_id={{ad.id}}, fbc_id={{adset.id}}) — die
    // numerischen Meta-IDs, Gegenstueck zu tw_adid/tw_campaign auf Google-Seite (18.08.26).
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'gclid', 'fbclid',
     'gbraid', 'wbraid', 'tw_campaign', 'tw_adid', 'tw_source', 'h_ad_id', 'fbc_id'].forEach(function (k) {
      var v = params.get(k);
      if (v) { touch[k] = v; found = true; }
    });
    if (found) {
      touch.lp = window.location.pathname;
      touch.ts = Date.now();
      store.last = touch;
      if (!store.first) store.first = touch;
      if (touch.fbclid) store.fbc = 'fb.1.' + Date.now() + '.' + touch.fbclid;
      store.t = Date.now(); // Fenster bei neuem Klick verlängern
    }
  }
  // Meta-Pixel-Cookies mitnehmen (können auch später gesetzt werden)
  var fbpCookie = getCookie('_fbp');
  if (fbpCookie) store.fbp = fbpCookie;
  var fbcCookie = getCookie('_fbc');
  if (fbcCookie) store.fbc = fbcCookie;
  writeStore(store);

  // In-Memory-Spiegel: falls localStorage blockiert ist, gehen die Kennungen
  // wenigstens innerhalb der Seite nicht verloren.
  var mem = store;

  // Klick-ID-Paket (27.09.26): gbraid/wbraid (Googles iOS-Klick-IDs) in eigenen Feldern statt im
  // gclid-Feld. Pruefung wie auf dem Server (Dashboard src/lib/google-klick.ts): nur Base64url-Zeichen,
  // 10 bis 200 Zeichen, sonst verworfen (nicht gekuerzt, eine halbe Klick-ID waere wertlos).
  // Stehen gclid und gbraid/wbraid in derselben URL, gehen alle mit; der Server waehlt
  // gclid vor wbraid vor gbraid.
  function braid(v) {
    v = String(v == null ? '' : v);
    return /^[A-Za-z0-9_-]{10,200}$/.test(v) ? v : '';
  }

  function get() {
    var d = readStore() || mem || {};
    var l = d.last || d.first || {};
    return {
      utm_source: l.utm_source || '',
      utm_medium: l.utm_medium || '',
      utm_campaign: l.utm_campaign || '',
      utm_content: l.utm_content || '',
      utm_term: l.utm_term || '',
      gclid: l.gclid || '',
      gbraid: braid(l.gbraid),
      wbraid: braid(l.wbraid),
      fbclid: l.fbclid || '',
      fbc: d.fbc || '',
      fbp: getCookie('_fbp') || d.fbp || '',
      campaign_id: l.tw_campaign || '',
      ad_id: l.tw_adid || l.h_ad_id || '',
      adset_id: l.fbc_id || '',
      vid: vid,
      sid: sid,
      landing: l.lp || landing || '',
      session_landing: landing || '',
      ref_host: refHost || ''
    };
  }
  window.EdelholzAttribution = { get: get };

  // --- Calendly-Links/Embeds dekorieren (utm_* + gepackte Klick-IDs) ---
  // Identitaets-Bruecke (23.9.26 abends): 'v:<vid>' als ERSTES Segment — die Besucher-ID
  // verbindet die Buchung mit der Website-Reise (Dashboard /api/calendly-poll → linkIdentity).
  // Calendly reicht salesforce_uuid nur begrenzt lang durch (bisher 250 Zeichen gekappt);
  // statt mitten im Wert abzuschneiden, fallen zu lange Segmente jetzt ganz weg — v: (<= 41
  // Zeichen) passt immer, eine halbe Klick-ID waere ohnehin wertlos.
  var PACKED_MAX = 250;
  function packedIds(a) {
    var parts = [];
    if (a.vid && /^[A-Za-z0-9]{1,40}$/.test(a.vid)) parts.push('v:' + a.vid);
    if (a.gclid) parts.push('g:' + a.gclid);
    // 27.09.26: b: = gbraid, w: = wbraid (Werte schon in get() geprueft, enthalten kein | oder :)
    if (a.gbraid) parts.push('b:' + a.gbraid);
    if (a.wbraid) parts.push('w:' + a.wbraid);
    if (a.fbc) parts.push('c:' + a.fbc);
    else if (a.fbclid) parts.push('f:' + a.fbclid);
    if (a.fbp) parts.push('p:' + a.fbp);
    var out = '';
    for (var i = 0; i < parts.length; i++) {
      var next = out ? out + '|' + parts[i] : parts[i];
      if (next.length <= PACKED_MAX) out = next;
    }
    return out;
  }
  function decorate() {
    var a = get();
    var qs = [];
    if (a.utm_source) qs.push('utm_source=' + encodeURIComponent(a.utm_source));
    if (a.utm_medium) qs.push('utm_medium=' + encodeURIComponent(a.utm_medium));
    if (a.utm_campaign) qs.push('utm_campaign=' + encodeURIComponent(a.utm_campaign));
    if (a.utm_content) qs.push('utm_content=' + encodeURIComponent(a.utm_content));
    if (a.utm_term) qs.push('utm_term=' + encodeURIComponent(a.utm_term));
    var packed = packedIds(a);
    if (packed) qs.push('salesforce_uuid=' + encodeURIComponent(packed));
    if (!qs.length) return;
    var q = qs.join('&');
    // data-url: Inline-Widget der Kontaktseite (edelholz-kontakt-2026, Calendly.initInlineWidget)
    // 18.10.2026: eigener Terminbucher (termin.edelholz-manufaktur.de) bekommt v=<vid> + utm_* direkt als Parameter
    var tq = [];
    if (a.vid && /^[A-Za-z0-9]{1,40}$/.test(a.vid)) tq.push('v=' + a.vid);
    if (a.utm_source) tq.push('utm_source=' + encodeURIComponent(a.utm_source));
    if (a.utm_campaign) tq.push('utm_campaign=' + encodeURIComponent(a.utm_campaign));
    if (tq.length) {
      var tqs = tq.join('&');
      Array.prototype.forEach.call(document.querySelectorAll('a[href*="termin.edelholz-manufaktur.de"],iframe[src*="termin.edelholz-manufaktur.de"],iframe[data-src*="termin.edelholz-manufaktur.de"]'), function (el) {
        ['href', 'src', 'data-src'].forEach(function (attrName) {
          var v = el.getAttribute && el.getAttribute(attrName);
          if (!v || v.indexOf('termin.edelholz-manufaktur.de') === -1 || v.indexOf('v=') > -1) return;
          el.setAttribute(attrName, v + (v.indexOf('?') > -1 ? '&' : '?') + tqs);
        });
      });
    }
    var els = document.querySelectorAll('a[href*="calendly.com"],iframe[src*="calendly.com"],iframe[data-src*="calendly.com"],[data-src*="calendly.com"],[data-url*="calendly.com"]');
    Array.prototype.forEach.call(els, function (el) {
      ['href', 'src', 'data-src', 'data-url'].forEach(function (attrName) {
        var v = el.getAttribute && el.getAttribute(attrName);
        if (!v || v.indexOf('calendly.com') === -1) return;
        if (v.indexOf('salesforce_uuid=') > -1) return; // schon dekoriert
        el.setAttribute(attrName, v + (v.indexOf('?') > -1 ? '&' : '?') + q);
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', decorate);
  } else {
    decorate();
  }
  setTimeout(decorate, 2500);   // Lazy-Embeds nachziehen

  // --- /api/beratung-Aufrufe transparent mit Attribution anreichern ---
  try {
    var _origFetch = window.fetch;
    window.fetch = function (input, init) {
      try {
        var url = (typeof input === 'string') ? input : ((input && input.url) || '');
        if (url.indexOf('/api/beratung') > -1 && init && typeof init.body === 'string' && init.method && String(init.method).toUpperCase() === 'POST') {
          var payload = JSON.parse(init.body);
          if (payload && typeof payload === 'object' && !payload.vid) {
            var a = get();
            if (!payload.pageUrl) payload.pageUrl = window.location.href;
            if (a.utm_source && !payload.utm_source) payload.utm_source = a.utm_source;
            if (a.utm_campaign && !payload.utm_campaign) payload.utm_campaign = a.utm_campaign;
            if (a.utm_content && !payload.utm_content) payload.utm_content = a.utm_content;
            if (a.gclid && !payload.gclid) payload.gclid = a.gclid;
            if (a.gbraid && !payload.gbraid) payload.gbraid = a.gbraid;
            if (a.wbraid && !payload.wbraid) payload.wbraid = a.wbraid;
            if (a.fbclid && !payload.fbclid) payload.fbclid = a.fbclid;
            if (a.fbc && !payload.fbc) payload.fbc = a.fbc;
            if (a.fbp && !payload.fbp) payload.fbp = a.fbp;
            // Journey-Bruecke: verbindet diese Anfrage mit dem bisherigen Verhalten
            if (a.vid) payload.vid = a.vid;
            if (a.sid) payload.sid = a.sid;
            if (a.session_landing && !payload.landing) payload.landing = a.session_landing;
            if (a.ref_host && !payload.ref_host) payload.ref_host = a.ref_host;
            init = Object.assign({}, init, { body: JSON.stringify(payload) });
          }
        }
      } catch (e) { /* nie den eigentlichen Request gefaehrden */ }
      return _origFetch.call(this, input, init);
    };
  } catch (e) {}

})();

/**
 * Block 2 — Contact Form → Close CRM Hook (dedupliziert, single-fire)
 * Slack + Close laufen SERVERSEITIG in /api/beratung (dort dedupliziert).
 */
(function () {
  if (window.__edelholzContactHookInit) return;   // include-once guard
  window.__edelholzContactHookInit = true;

  var ENDPOINT = 'https://dashboard.edelholz-manufaktur.de/api/beratung';

  document.addEventListener('submit', function (evt) {
    var form = evt.target;
    if (!form || typeof form.matches !== 'function') return;
    if (!form.matches('form[action="/contact#contact_form"], form[action="/contact"]')) return;
    if (form.__edelholzSent) return;             // fire at most once per form

    var data = new FormData(form);
    var name = '', email = '', phone = '', body = '';
    data.forEach(function (value, key) {
      if (key === 'contact[email]' || key === 'email') email = value;
      if (key === 'contact[name]' || key === 'name') name = value;
      if (key === 'contact[phone]' || key === 'phone') phone = value;
      if (key === 'contact[body]' || key === 'body' || key === 'contact[note]') body = value;
      if (key.indexOf('Name') > -1 || key.indexOf('name') > -1) { if (!name && value) name = value; }
      if (key.indexOf('Email') > -1 || key.indexOf('email') > -1 || key.indexOf('E-Mail') > -1) { if (!email && value) email = value; }
      if (key.indexOf('Phone') > -1 || key.indexOf('phone') > -1 || key.indexOf('Telefon') > -1) { if (!phone && value) phone = value; }
      if (key.indexOf('body') > -1 || key.indexOf('Nachricht') > -1 || key.indexOf('message') > -1) { if (!body && value) body = value; }
    });

    if (!email) return;                          // ohne E-Mail nichts zu tun
    form.__edelholzSent = true;

    var btn = form.querySelector('[type="submit"], button:not([type])');
    if (btn) btn.disabled = true;                // bremst Doppel-Klicks

    var ehIntern = false;
    try { ehIntern = localStorage.getItem('eh_intern') === '1'; } catch (e) {}

    var ehAttr = {};
    try {
      if (window.EdelholzAttribution && window.EdelholzAttribution.get) {
        ehAttr = window.EdelholzAttribution.get() || {};
      }
    } catch (e) {}

    try {
      var ehBody = {
        name: name || 'Kontaktformular',
        email: email,
        phone: phone || '',
        type: 'Kontaktformular',
        products: '',
        message: body || '',
        calendly: false,
        configCode: '',
        pageUrl: window.location.href,
        utm_source: ehAttr.utm_source || '',
        utm_campaign: ehAttr.utm_campaign || '',
        utm_content: ehAttr.utm_content || '',
        gclid: ehAttr.gclid || '',
        gbraid: ehAttr.gbraid || '',
        wbraid: ehAttr.wbraid || '',
        fbclid: ehAttr.fbclid || '',
        fbc: ehAttr.fbc || '',
        fbp: ehAttr.fbp || '',
        vid: ehAttr.vid || '',
        sid: ehAttr.sid || ''
      };
      // 23.09.26: interne Geraete (?eh_intern=1, siehe Block 3) → Testanfrage erkennbar
      if (ehIntern) ehBody.intern = 1;
      fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        keepalive: true,
        body: JSON.stringify(ehBody)
      }).then(function (res) {
        if (!res || !res.ok) fehler(res ? res.status : 'keine Response', 'HTTP');
      }).catch(function (e) { fehler('netz', e && e.message); });
    } catch (e) { fehler('js', e && e.message); }
    /* 22.09.26: Fehlschlag sichtbar machen (eh:track beratung_fehler -> Beacon bf_err + Clarity), Shopify-Formular geht trotzdem weiter. */
    function fehler(status, message) {
      try { window.dispatchEvent(new CustomEvent('eh:track', { detail: { name: 'beratung_fehler', data: { status: String(status || ''), message: String(message || '').slice(0, 160), quelle: 'kontaktseite' } } })); } catch (x) {}
    }
  }, true);                                        // capture phase: vor der Navigation
})();

/**
 * Block 3 — Engagement-Beacon (seit 10.9.26 fuer ALLE Besucher)
 * Misst Verweildauer, Scrolltiefe, Add-to-Cart,
 * Beratungs-Submits, Konfigurator-Tiefe — per sendBeacon an /api/track.
 * Keine Cookies, keine externen Dienste, keine Klarnamen/Mailadressen.
 */
(function () {
  if (window.__ehTrackInit) return; window.__ehTrackInit = true;
  function attr() { try { return (window.EdelholzAttribution && window.EdelholzAttribution.get()) || {}; } catch (e) { return {}; } }
  // Cookie lesen (Block 3 hat keinen Zugriff auf getCookie aus Block 1)
  function bCookie(name) {
    try {
      var m = String(document.cookie || '').match('(^|;)\\s*' + name + '=([^;]+)');
      return m ? decodeURIComponent(m[2]) : '';
    } catch (e) { return ''; }
  }
  var a = attr();

  /* --- Cookie-Banner-Varianten (27.09.26, Test-Modus umgebaut 29.09.26) ---
     Schalter: Theme-Setting eh_banner_variante (Theme-Einstellungen > Cookie-Banner), per Liquid als
     window.themeVariables.settings.bannerVariante (snippets/js-variables.liquid).
     Feste Variante fuer alle: 'v2' | 'w3' | 'w4' | 'w4l'. Test-Modus: Schluessel aus BV_TESTS, z. B.
     'test_v2_w4l' = 50/50 v2 gegen w4l. Zuteilung per Hash der vid (stabil auch ohne Speicher), gemerkt in
     localStorage 'eh_bv'; ein gemerkter Wert ausserhalb der Test-Arme wird neu zugeteilt. Nur im Test-Modus
     erzwingt ?eh_bv=<Arm> eine Variante (fuer Vorschau/Screens, wird ebenfalls gemerkt). Unbekannter Wert: 'v2'.
     Block 4 zeigt window.EdelholzBanner.variante, der Beacon meldet sie als cv (auch wenn der Besucher schon
     vorher entschieden hat, cs zeigt den Stand).
     Neuer Test = eine Zeile in BV_TESTS + eine Option im Schema (config/settings_schema.json). */
  var BV_LISTE = ['v2', 'w3', 'w4', 'w4l'];
  var BV_TESTS = { test_v2_w4l: ['v2', 'w4l'] };
  function bvGueltig(x, liste) { return (liste || BV_LISTE).indexOf(x) > -1; }
  function bvZuteilen(v, liste) {
    liste = liste || BV_TESTS.test_v2_w4l;
    // FNV-1a (32 Bit) + Murmur-Endmischung, damit auch aehnliche vids gleichmaessig streuen
    var s = String(v || ''), h = 0x811c9dc5;
    for (var i = 0; i < s.length; i++) { h ^= s.charCodeAt(i); h = Math.imul(h, 0x01000193) >>> 0; }
    h ^= h >>> 16; h = Math.imul(h, 0x85ebca6b) >>> 0; h ^= h >>> 13; h = Math.imul(h, 0xc2b2ae35) >>> 0; h ^= h >>> 16;
    return liste[(h >>> 0) % liste.length];
  }
  var bvModus = 'v2', bannerVariante = 'v2', bvArme = null;
  try {
    var bvSet = window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.bannerVariante;
    if (bvGueltig(bvSet) || (typeof bvSet === 'string' && Object.prototype.hasOwnProperty.call(BV_TESTS, bvSet))) bvModus = bvSet;
  } catch (e) {}
  if (Object.prototype.hasOwnProperty.call(BV_TESTS, bvModus)) bvArme = BV_TESTS[bvModus];
  if (!bvArme) bannerVariante = bvModus;
  else {
    var bvGemerkt = '';
    try { bvGemerkt = localStorage.getItem('eh_bv') || ''; } catch (e) {}
    var bvQ = /[?&]eh_bv=([a-z0-9]{1,8})(?:&|#|$)/.exec(String((window.location && window.location.search) || ''));
    bannerVariante = (bvQ && bvGueltig(bvQ[1], bvArme)) ? bvQ[1]
      : (bvGueltig(bvGemerkt, bvArme) ? bvGemerkt : bvZuteilen(a.vid || a.sid || '', bvArme));
    if (bannerVariante !== bvGemerkt) { try { localStorage.setItem('eh_bv', bannerVariante); } catch (e) {} }
  }
  window.EdelholzBanner = { variante: bannerVariante, modus: bvModus, arme: bvArme, zuteilen: bvZuteilen };

  /* --- Interne Geraete ausschliessen (23.09.26) ---
     Link https://edelholz-manufaktur.de/?eh_intern=1 markiert DIESEN Browser als intern
     (localStorage 'eh_intern' = '1', ohne Ablauf, gilt je Browser/Geraet/Domain);
     ?eh_intern=0 hebt die Markierung wieder auf. Jeder Beacon traegt dann intern: 1 →
     /api/track speichert intern = true, alle Auswertungen lassen den Besuch weg, und ein
     HotProspect geht serverseitig weder an Meta noch an Google. */
  try {
    var iqm = /[?&]eh_intern=([01])(?:&|#|$)/.exec(String((window.location && window.location.search) || ''));
    if (iqm) {
      if (iqm[1] === '1') localStorage.setItem('eh_intern', '1');
      else localStorage.removeItem('eh_intern');
      var iCon = window.console;
      if (iCon && iCon.info) {
        iCon.info(iqm[1] === '1'
          ? '[EDELHOLZ] Dieses Geraet ist als intern markiert – Besuche zaehlen nicht in den Auswertungen. Aufheben: ?eh_intern=0'
          : '[EDELHOLZ] Interne Markierung entfernt – Besuche zaehlen wieder.');
      }
    }
  } catch (e) {}
  function istIntern() {
    try { return localStorage.getItem('eh_intern') === '1'; } catch (e) { return false; }
  }

  // 10.9.26: KEIN Ad-Gate mehr — organische und direkte Besucher werden mitgemessen
  // (src = 'organic' bei fremdem Referrer, 'direct' ohne). Anonym wie bisher.
  var istWerbung = !!(a.utm_source || a.utm_campaign || a.utm_content || a.gclid || a.gbraid || a.wbraid || a.fbclid || a.campaign_id);
  var ENDPOINT = 'https://dashboard.edelholz-manufaktur.de/api/track';
  var sid = a.sid || 's0';   // aus Block 1 (dort immer gesetzt)
  var pv = 'p' + Math.random().toString(36).slice(2, 10);
  var dwell = 0, lastTick = Date.now(), maxScroll = 0, maxPx = 0, ev = { atc: 0, submit: 0, err: 0 }, sent = false;
  /* 22.09.26: gescheiterte Anfrage-Versendungen zaehlen (Popup + Kontaktseite melden eh:track beratung_fehler). Serverfeld bf_err legt das Pipeline-Projekt an. */
  window.addEventListener('eh:track', function (e) { try { if (e.detail && e.detail.name === 'beratung_fehler') ev.err++; } catch (x) {} });
  var vpH = window.innerHeight || 0;
  /* 27.09.26: act = aktive Zeit in ms. Zaehlt im selben 2-s-Takt wie dwell, aber nur bei sichtbarem Tab UND wenn
     die letzte echte Interaktion (scroll, click, keydown, touchstart, pointer-/mousemove, pointerdown; gedrosselt
     auf 500 ms) hoechstens 30 s zurueckliegt. Seitenstart und Rueckkehr in den Tab zaehlen als Interaktion. */
  var act = 0, actZuletzt = Date.now();
  function aktivMerken(e) {
    if (e && e.isTrusted === false) return;
    var n = Date.now(); if (n - actZuletzt >= 500) actZuletzt = n;
  }
  /* 30.09.26 (Ads-Session): act zaehlt auch ohne Interaktion weiter, solange ein vom Nutzer gestartetes Video laeuft
     (nicht pausiert, nicht beendet, Tab sichtbar). Nutzergestartet = nutzerVideo(), siehe unten; Autoplay-Deko nie. */
  /* 01.10.26 (Ads-Session, Android-Aufblaehung): Takt-Luecken zaehlen nicht. Android-WebViews (Instagram/Facebook)
     und Chrome melden beim Sperren oder App-Wechsel oft KEIN visibilitychange (hidden), die Timer stehen einfach.
     Bisher buchte der erste Takt danach die ganze Pause in dwell (und in act, wenn der Nutzer beim Zurueckkommen
     tippte). Jetzt: Liegt der letzte Takt mehr als 3 Takte (6 s) zurueck, gilt die Zeit als Pause und zaehlt weder
     in dwell noch in act; das Video-Kontingent (nvKontingent) wird um die Pause verschoben, also nicht verbraucht.
     Dasselbe gilt fuer versteckte Zeit (Tab hidden). 3 Takte = Puffer fuer ruckelnde Geraete/kurze Haenger. */
  var TAKT_MS = 2000, LUECKE_MS = 3 * TAKT_MS;
  function pauseUeberspringen(n) {
    var p = n - lastTick;
    lastTick = n;
    if (!(p > 0)) return;
    try {
      var vs = document.querySelectorAll('video');
      for (var i = 0; i < vs.length; i++) { if (vs[i] && vs[i].__ehNv) vs[i].__ehNv.t0 += p; }
    } catch (e) {}
  }
  function zeitBuchen() {
    var n = Date.now(), d = n - lastTick;
    if (document.hidden || d > LUECKE_MS || d < 0) { pauseUeberspringen(n); return; }
    dwell += d; if (n - actZuletzt <= 30000 || nutzerVideoLaeuft()) act += d;
    lastTick = n;
  }
  /* 30.09.26: nutzergestartete Videos - eine Logik fuer LP, Produktseiten und Konfigurator.
     - Video mit data-eh-nutzer (setzt eine Section beim Start durch den Nutzer, z. B. Produktseiten-Rundgaenge)
     - Rundgang-Karten (LP [data-eh-wk-card], Produktseiten [data-eh-pr-card]): laufen nur nach Tipp/Klick
     - Schritte-Regler [data-eh-stp]: erst nach dem ersten Nutzereingriff (Klasse is-user). Vorher laeuft Station 1
       stumm als Autoplay und zaehlt nicht.
     Nie: Videos mit autoplay-Attribut (Hero, Teaser, Fertigungs-Trio, stumme Loops). Das sind genau die Faelle, in
     denen die Sections eh:lp-video melden. */
  function nutzerVideo(v) {
    try {
      if (!v || v.tagName !== 'VIDEO' || v.autoplay || v.hasAttribute('autoplay')) return false;
      if (v.hasAttribute('data-eh-nutzer')) return true;
      if (v.closest('[data-eh-wk-card], [data-eh-pr-card]')) return true;
      var stp = v.closest('[data-eh-stp]');
      return !!(stp && stp.classList && stp.classList.contains('is-user'));
    } catch (e) { return false; }
  }
  /* 30.09.26 (Ads-Session, gegen Loop-Aufblaehung): ein Nutzer-Video zaehlt nur
     1) bis zu einem vollen Durchlauf seit Start bzw. letztem Nutzer-Eingriff: hoechstens duration + 2 s
        (duration unbekannt oder unendlich: 3 min). Gemessen in Uhrzeit ab Kontingent-Start; Schleifen danach zaehlen
        nicht. Ein neuer echter Eingriff (Klick/Tipp/Taste) in der Karte bzw. im Regler startet das Kontingent neu.
     2) solange die letzte Interaktion (Scroll, Tipp, Taste, Maus) hoechstens 10 min her ist.
     Gilt fuer act UND vid_secs.
     30.09.26 (Ads-Session, Punkt 6): Kaufbox- (data-mk-video), Konfigurator- (data-eh-stage) und Player-Videos
     (controls) - "Alt-Videos" - starten meist von selbst als stumme Schleife, sobald ihr Slide aktiv wird. Das ist
     Autoplay-Deko und zaehlt nie. Sie zaehlen nur, wenn der Nutzer sie selbst startet: echter Klick/Tipp auf das
     Video bzw. seinen Slide/seine Zelle (Pause/Play, Ton an) hoechstens 1 s vor dem Start, oder Klick waehrend es
     laeuft (Ton an). Dann dasselbe Kontingent wie oben. Wischen erzeugt keinen click, Pfeile/Thumbs liegen ausserhalb. */
  var NV_BEREICH = '[data-eh-wk-card], [data-eh-pr-card], [data-eh-stp]';
  function altVideo(v) {
    try {
      return !!(v && v.tagName === 'VIDEO' && !v.autoplay && !v.hasAttribute('autoplay') && (v.controls || v.hasAttribute('data-mk-video') || v.hasAttribute('data-eh-stage')));
    } catch (e) { return false; }
  }
  function nvKontingent(v) {
    var n = Date.now();
    if (n - actZuletzt > 600000) return false;
    var st = v.__ehNv;
    if (!st) st = v.__ehNv = { t0: n };
    var d = +v.duration;
    var grenze = (isFinite(d) && d > 0) ? d * 1000 + 2000 : 180000;
    return n - st.t0 <= grenze;
  }
  /* Zaehlt dieses Video in diesem Moment (act, vid_secs)? */
  function videoZaehltJetzt(v) {
    try {
      if (!v || v.paused || v.ended) return false;
      if (nutzerVideo(v)) return nvKontingent(v);
      if (altVideo(v)) return !!v.__ehNv && nvKontingent(v);
    } catch (e) {}
    return false;
  }
  /* Alt-Video zum Klickziel: das Video selbst oder ein direktes Kind der naechsten 4 Vorfahren (Slide/Zelle). */
  function altVideoBei(t) {
    for (var el = t, k = 0; el && k < 5; k++, el = el.parentElement) {
      if (el.tagName === 'VIDEO') return altVideo(el) ? el : null;
      var v = el.querySelector ? el.querySelector(':scope > video') : null;
      if (v) return altVideo(v) ? v : null;
    }
    return null;
  }
  function nvNeuStart(e, istKlick) {
    try {
      if (!e || e.isTrusted === false) return;
      var t = e.target; if (!t || !t.closest) return;
      var n = Date.now(), box = t.closest(NV_BEREICH), i, vs;
      if (box) { vs = box.querySelectorAll('video'); for (i = 0; i < vs.length; i++) vs[i].__ehNv = { t0: n }; return; }
      var tv = t.closest('video');
      if (tv && nutzerVideo(tv)) { tv.__ehNv = { t0: n }; return; }
      if (!istKlick) return;                        // Alt-Videos: nur echter Klick/Tipp, kein Wisch-Beginn
      var av = altVideoBei(t);
      if (!av) return;
      av.__ehKlick = n;
      if (!av.paused && !av.__ehNv) {                // z. B. Ton an waehrend der stummen Schleife: ab jetzt Nutzer-Start
        av.__ehNv = { t0: n };
        var k = av.currentSrc || av.getAttribute('src') || '';
        if (vidSet && !vidSet[k]) { vidSet[k] = 1; vidStarts++; }
      } else if (!av.paused) av.__ehNv = { t0: n };  // weiterer Eingriff: Kontingent neu
    } catch (x) {}
  }
  ['click', 'pointerdown', 'touchstart', 'keydown'].forEach(function (typ) {
    document.addEventListener(typ, function (e) { nvNeuStart(e, typ === 'click'); }, { capture: true, passive: true });
  });
  /* Kontingent beginnt mit dem Start (play), nicht erst beim naechsten Takt. Weiterlaufen nach Pause durch Scrollen
     (play ohne Eingriff) startet es bei Rundgaengen/Regler NICHT neu. Alt-Videos: play ohne Klick davor = Autoplay. */
  document.addEventListener('play', function (e) {
    try {
      var v = e.target, n = Date.now();
      if (nutzerVideo(v)) { if (!v.__ehNv) v.__ehNv = { t0: n }; return; }
      if (altVideo(v)) v.__ehNv = (n - (v.__ehKlick || 0) <= 1000) ? { t0: n } : null;
    } catch (x) {}
  }, true);
  function nutzerVideoLaeuft() {
    try {
      var vs = document.querySelectorAll('video');
      for (var i = 0; i < vs.length; i++) { if (videoZaehltJetzt(vs[i])) return true; }
    } catch (e) {}
    return false;
  }
  setInterval(zeitBuchen, TAKT_MS);
  ['click', 'keydown', 'touchstart', 'pointermove', 'mousemove', 'pointerdown'].forEach(function (typ) {
    document.addEventListener(typ, aktivMerken, { capture: true, passive: true });
  });
  window.addEventListener('scroll', aktivMerken, { passive: true });
  window.addEventListener('scroll', function () {
    try {
      var h = document.documentElement, d = (h.scrollHeight - h.clientHeight) || 1;
      var px = window.scrollY || h.scrollTop || 0;
      if (px > maxPx) maxPx = Math.round(px);
      var p = Math.round(px / d * 100);
      if (p > maxScroll) maxScroll = Math.min(p, 100);
    } catch (e) {}
  }, { passive: true });
  document.addEventListener('submit', function (e) {
    try { var f = e.target; if (f && f.getAttribute && /\/cart\/add/.test(f.getAttribute('action') || '')) ev.atc++; } catch (x) {}
  }, true);

  /* --- Abschnitte, Videos, Testimonial-Pfeile, Hero-Umschalter (15.09.26, Philipp-OK) ---
     Der Server (/api/track) erwartet sec_seen/sec_max/sec_mask/sec_total/vid_starts/vid_secs/tc_cards/hero_toggle
     seit 27.07., der Hook hat sie nie gesendet (100 % Nullen in der DB). Jetzt:
     Abschnitt = Template-Section (.shopify-section[id^=shopify-section-template--]), Reihenfolge = DOM.
     "gesehen" = mindestens 2 s irgendein Teil im Bild (Sekundentakt, nur bei sichtbarem Tab).
     Videos: nur bewusst gestartete (kein autoplay-Attribut; Kaufbox data-mk-video, Konfigurator-Buehne
     data-eh-stage oder Player mit controls), Sekunden nur waehrend sie laufen.
     30.09.26: "bewusst gestartet" jetzt wirklich geprueft (videoZaehltJetzt / vidZaehlt oben), mit Kontingent. */
  var secEls = [], secMs = [], secVis = {}, vidSet = {}, vidStarts = 0, vidMs = 0, tcCards = 0, heroToggle = 0;
  try {
    secEls = [].slice.call(document.querySelectorAll('.shopify-section[id^="shopify-section-template--"]')).slice(0, 40);
    if (secEls.length && 'IntersectionObserver' in window) {
      var secIO = new IntersectionObserver(function (es) {
        es.forEach(function (e) { var i = secEls.indexOf(e.target); if (i > -1) secVis[i] = e.isIntersecting; });
      }, { threshold: 0 });
      secEls.forEach(function (el) { secIO.observe(el); });
    }
    /* 30.09.26: Start zaehlt nur, wenn nutzergestartet: Rundgang-/Schritte-Clips (nutzerVideo) oder Alt-Video mit
       Klick direkt davor (__ehNv, gesetzt im play-Listener oben, der vor diesem laeuft). Stumme Kaufbox-/Konfigurator-
       Schleifen zaehlten bis hier faelschlich mit (Autoplay per JS, ohne autoplay-Attribut). Video-Buehne bleibt draussen. */
    var vidZaehlt = function (v) {
      return !!(v && v.tagName === 'VIDEO' && !v.autoplay && !v.hasAttribute('autoplay') && (nutzerVideo(v) || (altVideo(v) && !!v.__ehNv)));
    };
    document.addEventListener('play', function (e) {
      try { var v = e.target; if (!vidZaehlt(v)) return; var k = v.currentSrc || v.getAttribute('src') || ''; if (!vidSet[k]) { vidSet[k] = 1; vidStarts++; } } catch (x) {}
    }, true);
    document.addEventListener('click', function (e) {
      try {
        var t = e.target && e.target.closest ? e.target : null; if (!t) return;
        // 27.09.: Pfeile sind mobil (< 750 px) ausgeblendet, dort wird gewischt (siehe Messung v2); dazu Kundenfotos-Reihe
        if (t.closest('.edelholz-tc__arrow, [data-tc-prev], [data-tc-next], [data-eh-kw-pfeil]')) tcCards++;
        if (t.closest('.ehht__opt')) heroToggle++;
      } catch (x) {}
    }, true);
    var secLetzt = Date.now();
    setInterval(function () {
      try {
        // 01.10.26: eingefrorene Timer (eigene Takt-Luecke > 6 s) -> erst zeitBuchen, damit das Video-Kontingent um die
        // Pause verschoben ist, bevor videoZaehltJetzt fragt. vidMs selbst waechst ohnehin nur um 1 s je Takt.
        var sn = Date.now(), sLuecke = sn - secLetzt > LUECKE_MS; secLetzt = sn;
        if (document.hidden) return;
        if (sLuecke) zeitBuchen();
        for (var i in secVis) { if (secVis[i]) secMs[i] = (secMs[i] || 0) + 1000; }
        var vs = document.querySelectorAll('video'); var laeuft = false;
        for (var j = 0; j < vs.length; j++) { if (videoZaehltJetzt(vs[j])) { laeuft = true; break; } }
        if (laeuft) vidMs += 1000;
      } catch (x) {}
    }, 1000);
  } catch (e) {}
  function secWerte() {
    var seen = 0, max = 0, mask = 0;
    for (var i = 0; i < secEls.length; i++) {
      if ((secMs[i] || 0) > 0 && i + 1 > max) max = i + 1;
      if ((secMs[i] || 0) >= 2000) { seen++; mask += Math.pow(2, i); }
    }
    return { sec_seen: seen, sec_max: max, sec_mask: mask ? mask.toString(36) : '', sec_total: secEls.length,
      vid_starts: Math.min(vidStarts, 30), vid_secs: Math.min(Math.round(vidMs / 1000), 3600), tc_cards: tcCards, hero_toggle: heroToggle };
  }

  // --- Konfigurator-Tiefe ---
  // Wer den Konfigurator ernsthaft durchspielt, ist deutlich kaufnaeher als jemand,
  // der ihn nur oeffnet. WICHTIG: Die Schritte stehen untereinander — blosse
  // Sichtbarkeit waere nur Scrolltiefe. Gewertet wird deshalb die AUSWAHL:
  // ein Klick auf ein Bedienelement INNERHALB eines Schritts.
  var konfMax = 0;
  /* 15.09.26 (Marketing-Session, Philipp-OK): gleiche Ereignisse zusaetzlich als CustomEvent 'eh:track' -
     edelholz-clarity-events.js reicht sie an Microsoft Clarity weiter. Je Name+Schritt nur einmal pro Seitenaufruf.
     Am Beacon selbst aendert sich nichts. */
  var ehEmitted = {};
  function ehEmit(name, detail) {
    try {
      var k = name + ':' + (detail && detail.step != null ? detail.step : '');
      if (ehEmitted[k]) return; ehEmitted[k] = 1;
      window.dispatchEvent(new CustomEvent('eh:track', { detail: { name: name, data: detail || {} } }));
    } catch (e) {}
  }
  /* Konfigurator-Funnel (06.08.): welche Schritte bearbeitet, welche CTAs geklickt */
  var kMask = 0, kCta = 0, kInter = 0, kEns = 0, bfStep = 0, bfOpen = 0;
  /* 27.09.26: Auswahl zaehlt nur bei echten Nutzer-Ereignissen (isTrusted). Die Vorbelegung (z. B. Kaufbox ->
     Konfigurator klickt Modell/Groesse/Finish per Skript) blies k_inter, k_mask und konfig_step auf. */
  var kSum = 0, galSet = {}, gal = 0, k3d = 0, kRet = 0, konfWegMs = 0, konfSicht = null;
  function echt(e) { return !!(e && e.isTrusted === true); }
  function auswahl() { kInter++; if (konfWegMs >= 20000 && kRet < 50) kRet++; konfWegMs = 0; evPruefen(0); }
  // --- Produktseiten-Konfigurator (eh-mk, 10.9.26): Schritte = Groesse 2 / Finish 3 / Features 4 / Add-ons 5 ---
  try {
    if (document.querySelector('.eh-mk')) {
      konfMax = Math.max(konfMax, 1); kMask |= (1 << 1);
      // 17.09.: Kaufbox-Variante B (Klasse eh-kb-b auf <html>, Zuteilung in der Section) -> Bit 64 in kMask + Clarity-Event
      if (document.documentElement.classList.contains('eh-kb-b')) { kMask |= 64; ehEmit('kaufbox_b'); }
      var mkStep = function (evt) {
        try {
          var t = evt && evt.target; if (!t || !t.closest) return;
          if (!t.closest('.eh-mk')) return;
          var n = 0;
          if (t.closest('[data-mk-size]')) n = 2;
          else if (t.closest('[data-mk-finish]')) n = 3;
          else if (t.closest('[data-mk-feature], [data-mk-choice]')) n = 4;
          else if (t.closest('[data-mk-addon], [data-mk-achoice]')) n = 5;
          if (t.closest('[data-mk-atc]')) { kCta |= 1; ehEmit('kaufbox_warenkorb'); }
          if (t.closest('[data-mk-offer]')) { kCta |= 2; bfOpen++; ehEmit('kaufbox_angebot'); }
          if (t.closest('.eh-mk__leasing-link, [data-leasing-product]')) { kCta |= 4; ehEmit('kaufbox_leasing'); }
          if (t.closest('[data-mk-ber]')) { bfOpen++; ehEmit('kaufbox_beratung'); }
          if (t.closest('[data-mk-3d-btn]')) ehEmit('kaufbox_3d');
          if (!n || !echt(evt)) return;
          if (n > konfMax) konfMax = n; kMask |= (1 << n); auswahl();
          ehEmit('kaufbox_schritt', { step: n, max: konfMax });
        } catch (e) {}
      };
      document.addEventListener('click', mkStep, true);
      document.addEventListener('change', mkStep, true);
    }
  } catch (e) {}
  // --- Beratungsformular (Popup edelholz-bf, 10.9.26): geoeffnet + hoechster bearbeiteter Schritt ---
  try {
    document.addEventListener('click', function (evt) {
      try {
        var t = evt.target; if (!t || !t.closest) return;
        var st = t.closest('.edelholz-bf-step[data-step]');
        if (st) { var n = parseInt(st.getAttribute('data-step') || '0', 10); if (n > bfStep) { bfStep = n; ehEmit('beratung_schritt', { step: n }); } }
      } catch (e) {}
    }, true);
    var bfOv = document.getElementById('edelholz-bf-overlay');
    if (bfOv && window.MutationObserver) {
      var bfWarOffen = false;
      new MutationObserver(function () {
        try {
          var offen = bfOv.classList.contains('is-open') || bfOv.classList.contains('active') || bfOv.classList.contains('open') || (getComputedStyle(bfOv).display !== 'none' && getComputedStyle(bfOv).visibility !== 'hidden' && bfOv.getAttribute('aria-hidden') !== 'true');
          if (offen && !bfWarOffen) { bfOpen++; ehEmit('beratung_offen'); }
          bfWarOffen = offen;
        } catch (e) {}
      }).observe(bfOv, { attributes: true, attributeFilter: ['class', 'style', 'aria-hidden'] });
    }
  } catch (e) {}
  try {
    if (document.querySelector('.eh-config, [id^="desk-configurator"]')) {
      konfMax = 1;
      var seen = function (evt) {
        try {
          var t = evt && evt.target;
          if (!t || !t.closest || !echt(evt)) return;
          var el = t.closest('.eh-step[data-step]');
          if (!el) return;
          // Info-Buttons, Groessentabelle, Akkordeons und Karussell-Pfeile sind
          // KEINE Produktauswahl — ohne diesen Ausschluss zaehlte jeder
          // Info-Klick als "Schritt bearbeitet" (Tiefen-Inflation).
          if (t.closest('.eh-info-btn, .eh-link, .eh-accordion, .flickity-button, .flickity-page-dots, a')) return;
          if (!t.closest('button, [role="button"], input, label, select, .eh-chip, .eh-model, [data-value]')) return;
          var n = parseInt(el.getAttribute('data-step') || '0', 10);
          if (n > konfMax) konfMax = n;
          if (n >= 1 && n <= 12) { kMask |= (1 << n); auswahl(); ehEmit('konfig_schritt', { step: n, max: konfMax }); }
        } catch (e) {}
      };
      document.addEventListener('click', seen, true);
      document.addEventListener('change', seen, true);
      document.addEventListener('click', function (evt) {
        try {
          var t = evt.target; if (!t || !t.closest) return;
          if (t.closest('[data-role="add-to-cart"]')) { kCta |= 1; ehEmit('konfig_warenkorb'); }
          if (t.closest('#ehm-offer-link')) { kCta |= 2; ehEmit('konfig_angebot'); }
          if (t.closest('#ehm-leasing-cta')) { kCta |= 4; ehEmit('konfig_leasing'); }
          if (t.closest('[data-ens-card]')) { kEns++; ehEmit('konfig_ensemble'); }
          if (t.closest('[data-mk-3d-btn]')) ehEmit('konfig_3d');
        } catch (e) {}
      }, true);
    }
  } catch (e) {}

  /* --- Messung v2 (27.09.26, EngagedVisit-Analyse): eigene Beacon-Felder, NICHT in k_mask (Server kappt bei 8192) ---
     Ganzzahlig, je hoechstens 50, keine Inhalte. Nur echte Nutzer-Ereignisse (isTrusted); camera-change ist ein
     Ereignis des model-viewer selbst und wird ueber detail.source geprueft.
     k_sum: Sichtungen der Zusammenfassung (Kaufbox [data-mk-summe], Konfigurator .ehb-step--sum) nach mindestens
            einer eigenen Auswahl (k_inter >= 1): mind. 50 % des Elements oder die halbe Fensterhoehe im Bild, zwei
            Sekundentakte in Folge (also mind. 1 s) bei sichtbarem Tab. Neue Sichtung erst nach Verlassen des Bildes.
     gal:   verschiedene Galeriebilder, sobald der Nutzer die Galerie selbst bedient (Pfeil, Vorschaubild, Wischen
            >= 30 px quer), Startbild eingerechnet; 0 = nie bedient. Kaufbox: aktiver Slide (Medien-ID),
            Konfigurator: Sektionsbild [data-ehb-bild] (Bildnummer + Quelle). Gelesen sofort und nach 1,2 s.
     k3d:   0 = nie, 1 = 3D/AR-Knopf [data-mk-3d-btn] geklickt, 2 = Modell selbst gedreht (camera-change mit
            source user-interaction oder Ziehen >= 10 px auf model-viewer).
     k_ret: Rueckkehren zum Konfigurator: eigene Auswahl, nachdem .eh-mk/.eh-config seit der vorigen Auswahl
            insgesamt >= 20 s bei sichtbarem Tab komplett aus dem Bild war.
     tc_cards zaehlt zusaetzlich Wischen quer (>= 30 px) auf .edelholz-tc__track und [data-eh-kw-reihe]. */
  try {
    var sumEls = [].slice.call(document.querySelectorAll('[data-mk-summe], .ehb-step--sum')), sumVis = {}, sumSicht = false, sumTakte = 0, sumZaehlt = false;
    var konfEls = [].slice.call(document.querySelectorAll('.eh-mk, .eh-config')), konfVis = {};
    if ('IntersectionObserver' in window) {
      var stufen = []; for (var si = 0; si <= 20; si++) stufen.push(si / 20);
      var sumIO = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          var h = (e.rootBounds && e.rootBounds.height) || window.innerHeight || 1;
          sumVis[sumEls.indexOf(e.target)] = !!e.isIntersecting && (e.intersectionRatio >= 0.5 || ((e.intersectionRect && e.intersectionRect.height) || 0) >= h / 2);
        });
        sumSicht = false; for (var k in sumVis) { if (sumVis[k]) sumSicht = true; }
        if (!sumSicht) { sumTakte = 0; sumZaehlt = false; }
      }, { threshold: stufen });
      sumEls.forEach(function (el) { sumIO.observe(el); });
      var konfIO = new IntersectionObserver(function (es) {
        es.forEach(function (e) { konfVis[konfEls.indexOf(e.target)] = !!e.isIntersecting; });
        konfSicht = false; for (var k in konfVis) { if (konfVis[k]) konfSicht = true; }
      }, { threshold: 0 });
      konfEls.forEach(function (el) { konfIO.observe(el); });
    }
    setInterval(function () {
      if (document.hidden) return;
      if (sumSicht && kInter > 0 && !sumZaehlt && ++sumTakte >= 2) { sumZaehlt = true; if (kSum < 50) kSum++; }
      if (kInter > 0 && konfSicht === false) konfWegMs += 1000;
    }, 1000);
    var galMerk = function (z) {
      try {
        var key = '';
        if (z.hasAttribute('data-ehb-bild')) {
          var im = z.querySelector('.ehb-bild__img');
          key = 'b' + (z.__idx || 0) + ':' + String((im && im.getAttribute('src')) || '').split('?')[0];
        } else {
          var sl = z.querySelector('[data-mk-slide].aktiv');
          key = sl ? 'm' + (sl.getAttribute('data-mk-media-id') || '') : '';
        }
        if (key && !galSet[key] && gal < 50) { galSet[key] = 1; gal++; }
      } catch (x) {}
    };
    var galBedient = function (z) { if (!z) return; galMerk(z); setTimeout(function () { galMerk(z); }, 1200); };
    document.addEventListener('click', function (e) {
      try {
        var t = e.target; if (!echt(e) || !t || !t.closest) return;
        if (t.closest('[data-mk-gnav], [data-mk-thumb]')) galBedient(t.closest('.eh-mk'));
        else if (t.closest('[data-ehb-prev], [data-ehb-next]')) galBedient(t.closest('[data-ehb-bild]'));
        if (t.closest('[data-mk-3d-btn]') && k3d < 1) k3d = 1;
      } catch (x) {}
    }, true);
    var tStart = null, mvDown = null;
    document.addEventListener('touchstart', function (e) {
      try { var p = e.touches && e.touches[0]; tStart = (echt(e) && p && e.touches.length === 1) ? { x: p.clientX, y: p.clientY, t: e.target } : null; } catch (x) {}
    }, { capture: true, passive: true });
    document.addEventListener('touchend', function (e) {
      try {
        var s = tStart, p = e.changedTouches && e.changedTouches[0]; tStart = null;
        if (!s || !p || !echt(e) || !s.t || !s.t.closest) return;
        var dx = p.clientX - s.x, dy = p.clientY - s.y;
        if (Math.abs(dx) < 30 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
        if (s.t.closest('.edelholz-tc__track, [data-eh-kw-reihe]')) tcCards++;
        else if (s.t.closest('[data-mk-spur]')) galBedient(s.t.closest('.eh-mk'));
        else if (s.t.closest('[data-ehb-bild]')) galBedient(s.t.closest('[data-ehb-bild]'));
      } catch (x) {}
    }, { capture: true, passive: true });
    document.addEventListener('camera-change', function (e) {
      try { if (e.detail && e.detail.source === 'user-interaction') k3d = 2; } catch (x) {}
    }, true);
    document.addEventListener('pointerdown', function (e) {
      try { var t = e.target; mvDown = echt(e) && t && t.closest && t.closest('model-viewer') ? { x: e.clientX, y: e.clientY } : null; } catch (x) {}
    }, true);
    document.addEventListener('pointerup', function () { mvDown = null; }, true);
    document.addEventListener('pointermove', function (e) {
      try { if (mvDown && echt(e) && Math.abs(e.clientX - mvDown.x) + Math.abs(e.clientY - mvDown.y) >= 10) k3d = 2; } catch (x) {}
    }, { capture: true, passive: true });
  } catch (e) {}

  try {
    var _tf = window.fetch;
    window.fetch = function (input, init) {
      try {
        var u = (typeof input === 'string') ? input : ((input && input.url) || '');
        if (init && String(init.method || '').toUpperCase() === 'POST') {
          if (u.indexOf('/api/beratung') > -1) { ev.submit++; ehEmit('beratung_gesendet'); }
          // Der Konfigurator legt per fetch('/cart/add.js') in den Warenkorb —
          // das ist KEIN Form-Submit und wurde bisher komplett verpasst.
          if (u.indexOf('/cart/add') > -1) { ev.atc++; ehEmit('warenkorb'); }
        }
      } catch (x) {}
      return _tf.apply(this, arguments);
    };
  } catch (e) {}

  /* --- Journey & Intent WP2 (23.09.26): Besuchs-Kontobuch + Muster A ---
     localStorage 'eh_journey' = { days: ['YYYYMMDD', ...] (max 60, lokales Datum), kmax: hoechster
     Konfigurator-Schritt, dwell: Verweildauer in Sekunden ueber alle Besuche, hotSentAt: ISO | '' }.
     Aktualisiert per Heartbeat (15 s, nur bei sichtbarem Tab) und beim Senden (pagehide/hidden).
     Jeder Seitenaufruf schreibt nur SEINE neue Verweildauer gut (jGut) — keine Doppelzaehlung,
     auch nicht bei mehreren Tabs. Ein Tag zaehlt beim ersten Update des Seitenaufrufs oder
     wenn sichtbare Zeit dazukam (ein ueber Nacht verstecktes Tab erzeugt keinen zweiten Tag).
     Muster A v2 = (days.length >= 2 && (kmax >= 3 || bfo >= 1 || dwell >= 600)) || (atc >= 1 && pvs >= 2)
     (atc = je Warenkorb, bfo = je Beratungs-Popup geoeffnet, pvs = Seitenaufrufe). E2E-Review 24.09.26:
     Warenkorb erst ab dem ZWEITEN Seitenaufruf — genau so prueft /api/track serverseitig; vorher
     verwarf der Server Warenkorb-Signale vom Einstiegs-Seitenaufruf (22 % aller Warenkorb-Besucher),
     und das Theme sperrte sich danach 30 Tage. Nach dem Warenkorb-Klick feuert das Signal jetzt auf
     der naechsten Seite (meist /cart). Beim ersten Erreichen (bzw. wenn
     hotSentAt aelter als 30 Tage): eventID = 'hot-' + vid + '-' + YYYYMMDD → fbq trackCustom
     EDELHOLZ_HotProspect (nur wenn der Pixel geladen ist) + sofort ein Beacon mit hot: eventID.
     Ohne localStorage (Safari privat) lebt das Kontobuch nur im Speicher → nie 2 Tage → kein Signal. */
  var J_KEY = 'eh_journey', J_TAGE_MAX = 60, J_ERNEUT_MS = 30 * 24 * 3600 * 1000;
  // 23.9.26 (Datenschutz): Tage aelter als J_AUFBEWAHRUNG_TAGE werden verworfen (24.9.26: 365). Bleibt kein Tag uebrig,
  // beginnt das Kontobuch neu (kmax/dwell/atc/bfo/hotSentAt stammen dann aus der alten Zeit).
  var J_AUFBEWAHRUNG_TAGE = 365;
  var jMem = null, jGut = 0, jErstes = true, jHotFertig = false;
  var jTz = '', jLang = '', jScr = '';
  try { jTz = String(Intl.DateTimeFormat().resolvedOptions().timeZone || ''); } catch (e) {}
  try { jLang = String(navigator.language || navigator.userLanguage || ''); } catch (e) {}
  try { jScr = (screen.width || 0) + 'x' + (screen.height || 0) + 'x' + (Math.round((window.devicePixelRatio || 1) * 100) / 100); } catch (e) {}
  // 24.9.26: Tagesschluessel in Europe/Berlin (wie der Server), nicht nach Browser-Uhr;
  // Rueckfall auf die Browser-Uhr, wenn Intl die Zeitzone nicht kennt.
  function jDatum(d) {
    try {
      var s = d.toLocaleDateString('sv-SE', { timeZone: 'Europe/Berlin' });
      if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s.replace(/-/g, '');
    } catch (e) {}
    var m = d.getMonth() + 1, t = d.getDate();
    return '' + d.getFullYear() + (m < 10 ? '0' : '') + m + (t < 10 ? '0' : '') + t;
  }
  // Tag beim Seitenstart festhalten: ein ueber Mitternacht offener Tab zaehlt als EIN Tag
  var jTagStart = jDatum(new Date());
  function jTag() { return jTagStart; }
  function jGrenze() {
    // Datum vor J_AUFBEWAHRUNG_TAGE Tagen als YYYYMMDD (Vergleich als String, wie die Eintraege)
    return jDatum(new Date(Date.now() - J_AUFBEWAHRUNG_TAGE * 24 * 3600 * 1000));
  }
  function jLesen() {
    var r = null;
    try { r = JSON.parse(localStorage.getItem(J_KEY) || 'null'); } catch (e) { r = null; }
    if (!r || typeof r !== 'object') r = jMem || {};
    var tage = [], hatteTage = false, grenze = jGrenze();
    if (r.days && r.days.length) {
      for (var i = 0; i < r.days.length && i < 200; i++) {
        var d = String(r.days[i]);
        if (!/^\d{8}$/.test(d)) continue;
        hatteTage = true;
        if (d >= grenze && tage.indexOf(d) === -1) tage.push(d);
      }
    }
    if (hatteTage && !tage.length) r = {}; // alles aelter als die Aufbewahrung → Kontobuch neu
    return {
      days: tage,
      kmax: Math.max(0, Math.min(+r.kmax || 0, 12)),
      dwell: Math.max(0, Math.floor(+r.dwell || 0)),
      hotSentAt: typeof r.hotSentAt === 'string' ? r.hotSentAt : '',
      // Seitenaufrufe; aeltere Kontobuecher ohne Feld: mindestens ein Aufruf je gespeichertem Tag
      pvs: Math.max(0, Math.min(Math.floor(+r.pvs || 0), 100000), tage.length),
      atc: (+r.atc || 0) > 0 ? 1 : 0,   // je in den Warenkorb gelegt (Backtest: 1,9 % Lead-Quote)
      bfo: (+r.bfo || 0) > 0 ? 1 : 0    // je Beratungs-Popup/Kaufbox geoeffnet
    };
  }
  function jSchreiben(j) {
    jMem = j;
    try { localStorage.setItem(J_KEY, JSON.stringify(j)); } catch (e) {}
  }
  function jAktualisieren() {
    try {
      var j = jLesen();
      var neu = Math.floor((dwell - jGut) / 1000);
      if (neu > 0) { j.dwell += neu; jGut += neu * 1000; }
      if (jErstes) j.pvs += 1;   // jeder Seitenaufruf zaehlt genau einmal
      if (jErstes || neu > 0) {
        var heute = jTag();
        if (j.days.indexOf(heute) === -1) j.days.push(heute);
        j.days.sort();
        if (j.days.length > J_TAGE_MAX) j.days = j.days.slice(j.days.length - J_TAGE_MAX);
      }
      jErstes = false;
      if (konfMax > j.kmax) j.kmax = konfMax;
      if (ev.atc > 0) j.atc = 1;
      if (bfOpen > 0) j.bfo = 1;
      jSchreiben(j);
      jPruefeHot(j);
    } catch (e) {}
  }
  function jPruefeHot(j) {
    if (jHotFertig) return;
    // Muster A v2 (Backtest 23.09., gesamte Historie): wiederkehrend UND (Konfigurator ab Schritt 3
    // ODER Beratungs-Popup geoeffnet ODER >= 10 Min gesamt) ODER irgendwann in den Warenkorb gelegt.
    var heiss = (j.days.length >= 2 && (j.kmax >= 3 || j.bfo >= 1 || j.dwell >= 600)) || (j.atc >= 1 && j.pvs >= 2);
    if (!heiss) return;
    if (j.hotSentAt) {
      var alt = Date.parse(j.hotSentAt);
      if (!(isFinite(alt) && (Date.now() - alt) > J_ERNEUT_MS)) return; // unlesbar → nicht erneut feuern
    }
    var v = String(a.vid || '');
    if (!/^[A-Za-z0-9]{1,40}$/.test(v)) return;
    jHotFertig = true;
    var eventID = 'hot-' + v + '-' + jTag();
    // Zuerst merken, dann feuern — ein paralleler Tab/Heartbeat sieht hotSentAt sofort
    j.hotSentAt = new Date().toISOString();
    jSchreiben(j);
    // Interne Geraete (eh_intern = '1'): kein Pixel-Event — der Beacon mit hot geht weiter
    // (traegt intern: 1, der Server verwirft ihn), damit hotSentAt/Drossel gleich bleiben.
    try { if (!istIntern() && typeof window.fbq === 'function') window.fbq('trackCustom', 'EDELHOLZ_HotProspect', {}, { eventID: eventID }); } catch (e) {}
    try { beacon(payload({ hot: eventID })); } catch (e) {}
  }
  setInterval(function () { if (!document.hidden) jAktualisieren(); }, 15000);

  /* --- EngagedVisit v2 (27.9.26): Browser-Zwilling zum Server-Event EDELHOLZ_EngagedVisit, gleiche eventID
     'ev-<vid>-<JJJJMMTT>' (Berliner Tag vom Seitenstart, wie HotProspect). Feuert, sobald am selben Tag 2 von 3
     Bausteinen erfuellt sind: k5 = auf einem Seitenaufruf konfig_step >= 5 und k_inter >= 2; rueckkehr = auf
     >= 2 Seitenaufrufen k_inter > 0 (je Seitenaufruf einmal gezaehlt, sobald die erste echte Auswahl faellt);
     zeit = Summe act (aktive Zeit) aller Seitenaufrufe >= 300 s. Tageszaehler localStorage 'eh_ev_tag' =
     { tag, k5, konfigPvs, actMs }, anderer Tag = neu. Jeder Seitenaufruf schreibt nur SEINE neue act gut (evActGut),
     gedrosselt auf 10 s, beim Senden vollstaendig. Gesendet nur mit Pixel (Consent), nicht intern, hoechstens alle
     30 Tage je Besucher ('eh_ev_sent'); ist der Speicher nicht nutzbar, wird nichts gesendet. */
  var EV_KEY = 'eh_ev_tag', evFertig = false, evPvGezaehlt = false, evActGut = 0;
  function evPruefen(voll) {
    if (evFertig) return;
    try {
      var roh = localStorage.getItem(EV_KEY), d = null, heute = jTag(), neu = false;
      try { d = JSON.parse(roh || 'null'); } catch (x) {}
      if (!d || typeof d !== 'object' || !/^\d{8}$/.test(d.tag)) d = null;
      if (d && d.tag > heute) return; // Tab vom Vortag: der Zaehler gehoert schon dem neuen Tag
      if (!d || d.tag !== heute) d = { tag: heute, k5: 0, konfigPvs: 0, actMs: 0 };
      if (!d.k5 && konfMax >= 5 && kInter >= 2) { d.k5 = 1; neu = true; }
      if (!evPvGezaehlt && kInter > 0) { evPvGezaehlt = true; d.konfigPvs = (+d.konfigPvs || 0) + 1; neu = true; }
      if (act - evActGut >= (voll ? 1 : 10000)) { d.actMs = (+d.actMs || 0) + act - evActGut; evActGut = act; neu = true; }
      if (neu) localStorage.setItem(EV_KEY, JSON.stringify(d));
      var b = [];
      if (d.k5) b.push('k5');
      if (d.konfigPvs >= 2) b.push('rueckkehr');
      if (d.actMs >= 300000) b.push('zeit');
      if (b.length < 2 || typeof window.fbq !== 'function' || istIntern()) return;
      var v = String(a.vid || '');
      if (!/^[A-Za-z0-9]{1,40}$/.test(v)) return;
      evFertig = true;
      if (Date.now() - (+localStorage.getItem('eh_ev_sent') || 0) < J_ERNEUT_MS) return;
      localStorage.setItem('eh_ev_sent', String(Date.now()));
      window.fbq('trackCustom', 'EDELHOLZ_EngagedVisit', { version: 2, weg: b.length > 2 ? 'alle' : b.join('+'),
        bausteine: b.join(','), konfig_step: konfMax, klicks: kInter }, { eventID: 'ev-' + v + '-' + heute });
    } catch (e) {}
  }
  setInterval(function () { evPruefen(0); }, 2000);

  /* --- Identitaets-Bruecken (23.09.26 abends) ---
     Mail: Klick auf a[href^="mailto:"] → Betreff bekommt den Code '[J-<vid>]' (neu:
     'Anfrage EDELHOLZ [J-<vid>]', vorhandener Betreff wird ergaenzt, body & Co. bleiben
     unveraendert, ein vorhandener [J-…]-Code wird nicht gedoppelt). Eingehende Mail in Close
     → Close-Webhook verknuepft Absender und vid (sicher).
     Telefon: Klick auf a[href^="tel:"] → sofort ein Beacon mit tel: 1 (hoechstens alle 60 s).
     Eingehender Anruf in Close (sipgate) → Webhook sucht tel-Klicks der 15 Minuten davor und
     verknuepft nur bei genau EINEM Besucher (unsicher, Konfidenz 0.5).
     Capture-Phase, die Navigation wird nie verhindert. */
  var J_CODE_RE = /\[J-[A-Za-z0-9]+\]/, jTelZuletzt = 0;
  function jMailtoMitCode(href, code) {
    var q = href.indexOf('?');
    var basis = q > -1 ? href.slice(0, q) : href;
    var teile = q > -1 && href.length > q + 1 ? href.slice(q + 1).split('&') : [];
    var marke = '[J-' + code + ']', gefunden = false;
    for (var i = 0; i < teile.length; i++) {
      var gl = teile[i].indexOf('=');
      var key = gl > -1 ? teile[i].slice(0, gl) : teile[i];
      if (String(key).toLowerCase() !== 'subject' || gefunden) continue;
      gefunden = true;
      var alt = gl > -1 ? teile[i].slice(gl + 1) : '';
      var text = alt;
      try { text = decodeURIComponent(alt); } catch (e) {}
      if (J_CODE_RE.test(text)) return href; // schon markiert
      text = text ? text + ' ' + marke : 'Anfrage EDELHOLZ ' + marke;
      teile[i] = key + '=' + encodeURIComponent(text);
    }
    if (!gefunden) teile.push('subject=' + encodeURIComponent('Anfrage EDELHOLZ ' + marke));
    return basis + '?' + teile.join('&');
  }
  document.addEventListener('click', function (evt) {
    try {
      var t = evt && evt.target; if (!t || !t.closest) return;
      var link = t.closest('a[href^="mailto:"], a[href^="tel:"]');
      if (!link || !link.getAttribute) return;
      var href = String(link.getAttribute('href') || '');
      var v = String(a.vid || '');
      if (/^mailto:/i.test(href)) {
        if (!/^[A-Za-z0-9]{6,40}$/.test(v)) return;
        var neu = jMailtoMitCode(href, v);
        if (neu !== href) link.setAttribute('href', neu);
      } else if (/^tel:/i.test(href)) {
        var jetzt = Date.now();
        if (jetzt - jTelZuletzt < 60000) return;
        jTelZuletzt = jetzt;
        beacon(payload({ tel: 1 }));
      }
    } catch (e) {}
  }, true);

  // E2E-Review 24.09.26: Werte aus URL/Store so kappen wie der Server (/api/track) — sonst kann ein
  // sehr langer UTM-Wert den ganzen Beacon ueber das Server-Limit schieben.
  function kap(v, n) { return String(v == null ? '' : v).slice(0, n); }
  /* 27.9.26: Consent-Stand im Beacon. cs = none | later | denied | all |
     custom:<a><m><p> (Statistik, Marketing, Komfort je 0/1), cv = zugeteilte Banner-Variante (v2 | w3 | w4 | w4l, siehe oben). Quelle in dieser Reihenfolge:
     eh_consent_v1 (Block 4), eh_consent_later, Shopify customerPrivacy. Klick im Banner: nach 3 s ein zusaetzlicher
     Beacon (dann sind Wahl und Pixel-Cookies gespeichert), entfaellt, wenn send() vorher laeuft (Navigation, Tab weg). */
  var CONSENT_VARIANTE = bannerVariante, csTimer = 0, csKlick = '';
  function csCode(an, ma, pr) {
    var z = (an ? '1' : '0') + (ma ? '1' : '0') + (pr ? '1' : '0');
    return z === '111' ? 'all' : (z === '000' ? 'denied' : 'custom:' + z);
  }
  function csLesen() {
    var c = null;
    try { c = JSON.parse(localStorage.getItem('eh_consent_v1') || 'null'); c = c && c.c; } catch (e) { c = null; }
    if (c && typeof c === 'object') return csCode(c.analytics === true, c.marketing === true, c.preferences === true);
    try { if (sessionStorage.getItem('eh_consent_later')) return 'later'; } catch (e) {}
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      var ok = { yes: 1, no: 1 };
      c = cp && cp.currentVisitorConsent ? cp.currentVisitorConsent() : null;
      if (c && (ok[c.analytics] || ok[c.marketing] || ok[c.preferences])) {
        return csCode(c.analytics === 'yes', c.marketing === 'yes', c.preferences === 'yes');
      }
    } catch (e) {}
    return 'none';
  }
  document.addEventListener('click', function (evt) {
    try {
      var t = evt && evt.target;
      if (!t || !t.closest || !t.closest('.eh-c-accept, .eh-c-decline, .eh-c-save, .eh-c-x')) return;
      // "Auswahl speichern" mit drei leeren Haken meldet dieser Seitenaufruf als custom:000 (gespeichert ist es denied)
      var box = t.closest('.eh-c-save') && t.closest('.eh-consent');
      var ins = box && box.querySelectorAll ? box.querySelectorAll('input[data-k]') : [];
      csKlick = ins.length === 3 && !ins[0].checked && !ins[1].checked && !ins[2].checked ? 'custom:000' : '';
      if (csTimer) clearTimeout(csTimer);
      csTimer = setTimeout(function () { csTimer = 0; try { beacon(payload()); } catch (e) {} }, 3000);
    } catch (e) {}
  }, true);
  // 29.9.26: Shopify-Besucher-ID aus dem Shopify-Tracker, nur wenn Shopify Statistik erlaubt.
  function syTracker() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp || typeof cp.analyticsProcessingAllowed !== 'function' || cp.analyticsProcessingAllowed() !== true) return '';
      return String(window.ShopifyAnalytics.lib.user().traits().uniqToken || '');
    } catch (e) { return ''; }
  }
  function payload(extra) {
    var p = {
      sid: sid, vid: a.vid || '', pv: pv, path: kap(location.pathname, 300),
      mob: window.matchMedia('(max-width: 749px)').matches ? 1 : 0,
      scroll_px: maxPx, vp_h: vpH,
      dwellMs: dwell, act: Math.min(act, 3600000), scrollPct: maxScroll, atc: ev.atc, submit: ev.submit,
      utm_source: kap(a.utm_source, 120), utm_campaign: kap(a.utm_campaign, 180), utm_content: kap(a.utm_content, 180),
      gclid: kap(a.gclid, 200), gbraid: kap(a.gbraid, 200), wbraid: kap(a.wbraid, 200),
      campaign_id: kap(a.campaign_id, 40), ad_id: kap(a.ad_id, 40),
      konfig_step: konfMax,
      k_mask: kMask, k_cta: kCta, k_inter: kInter, k_ens: kEns,
      k_sum: kSum, gal: gal, k3d: k3d, k_ret: kRet,
      bf_step: bfStep, bf_open: bfOpen, bf_err: ev.err,
      landing: kap(a.session_landing, 300), ref_host: kap(a.ref_host, 80),
      src: (a.gclid || a.gbraid || a.wbraid || a.campaign_id) ? 'google' : ((a.fbclid || a.fbc) ? 'meta' : (istWerbung ? 'utm' : (a.ref_host ? 'organic' : 'direct')))
    };
    try { var sw = secWerte(); for (var sk in sw) p[sk] = sw[sk]; } catch (x) {}
    // WP2: Meta-IDs frisch lesen (der Pixel setzt _fbp oft erst nach dem Laden), nur wenn vorhanden.
    // Review-Fix 23.09. abends (M4, Consent): NUR aus den Cookies _fbp/_fbc, die der Meta-Pixel
    // erst mit Marketing-Consent setzt — nie aus dem localStorage-Store (dort liegt eine aus
    // fbclid gebaute fbc auch ohne Consent). Kein Cookie = kein fbp/fbc im Beacon.
    try {
      var cFbp = bCookie('_fbp');
      var cFbc = bCookie('_fbc');
      if (cFbp) p.fbp = String(cFbp).slice(0, 100);
      if (cFbc) p.fbc = String(cFbc).slice(0, 300);
      // 24.9.26: Shopify-Besucher-ID _shopify_y (iPhone-Wiedererkennung, Dashboard 1.4.9).
      // Nur wenn Cookie da und Wert gueltig, sonst Feld weglassen (Server verwirft Ungueltiges).
      // Shopify setzt das Cookie erst nach Analytics-Einwilligung, keine eigene Pruefung noetig.
      // 29.9.26: Shopify setzt _shopify_y seit 25.09. abends nicht mehr (nur Altbestand kommt noch).
      // Gleiche Kennung jetzt: Cookie shopify_client_id (Shopify, nur mit Statistik UND Marketing),
      // sonst Tracker-Wert uniqToken (Web-Pixel-clientId), den wir NUR bei Statistik-Einwilligung
      // lesen (wie frueher _shopify_y). Ein alter _shopify_y-Wert wird von Shopify uebernommen,
      // die Bruecke bleibt also gleich. Ohne Einwilligung liefert Shopify 00000000-0000-0000-..., nie senden.
      var syKand = [bCookie('_shopify_y'), bCookie('shopify_client_id'), syTracker()];
      for (var si = 0; si < syKand.length; si++) {
        var cSy = String(syKand[si] || '');
        if (/^[A-Za-z0-9-]{1,64}$/.test(cSy) && !/^0{8}-0{4}-0{4}-/.test(cSy)) { p.sy = cSy; break; }
      }
      // 29.9.26: Clarity-IDs fuer Slack-Links zu Aufnahmen (Dashboard). _clck/_clsk gibt es nur
      // nach Clarity-Einwilligung, daher keine eigene Pruefung. Erster Teil vor dem Trenner, sonst weglassen.
      // Fix 29.9.26: clarity.js 0.8.x trennt mit "^" (_clck=luzp38^2^g9v^1^2463), aeltere Versionen mit "|".
      var cClk = String(bCookie('_clck') || '').split(/[|^]/)[0];
      var cCls = String(bCookie('_clsk') || '').split(/[|^]/)[0];
      if (/^[a-z0-9]{4,32}$/.test(cClk)) p.clk = cClk;
      if (/^[a-z0-9]{4,32}$/.test(cCls)) p.cls = cCls;
    } catch (x) {}
    if (jTz) p.tz = jTz.slice(0, 64);
    if (jLang) p.lang = jLang.slice(0, 20);
    if (jScr) p.scr = jScr.slice(0, 24);
    if (istIntern()) p.intern = 1;
    p.cs = csLesen(); p.cv = CONSENT_VARIANTE;
    if (csKlick && p.cs === 'denied') p.cs = csKlick;
    if (extra) { for (var ek in extra) p[ek] = extra[ek]; }
    return p;
  }
  function beacon(p) {
    navigator.sendBeacon(ENDPOINT, new Blob([JSON.stringify(p)], { type: 'text/plain' }));
  }

  function send() {
    if (sent) return; sent = true;
    if (csTimer) { clearTimeout(csTimer); csTimer = 0; }
    try {
      zeitBuchen();
      jAktualisieren();
      evPruefen(1);
      beacon(payload());

      // Meta-Pixel-Spiegelung: nur wenn der Pixel wirklich geladen ist (haengt am
      // Marketing-Consent). Nice-to-have fuer Audiences — die belastbare Quelle
      // bleibt unser eigener Beacon + der Server-Weg.
      try {
        // 27.9.26: ein Flag je Event (vorher ein gemeinsames): jedes Event feuert einmal je
        // Seitenaufruf, sobald seine Bedingung erfuellt ist, auch nach App-Wechsel/Verstecken.
        if (typeof window.fbq === 'function') {
          var fl = window.__ehFbq || (window.__ehFbq = {});
          if (dwell >= 60000 && !fl.e60) { fl.e60 = 1; window.fbq('trackCustom', 'EH_Engaged60s'); }
          if (maxScroll >= 75 && !fl.s75) { fl.s75 = 1; window.fbq('trackCustom', 'EH_Scroll75'); }
          if (konfMax >= 3 && !fl.kd) { fl.kd = 1; window.fbq('trackCustom', 'EH_KonfiguratorDeep', { step: konfMax }); }
        }
      } catch (e) {}
    } catch (e) {}
  }
  window.addEventListener('pagehide', send);
  /* Nutzer kommt zurueck → aktualisierte Summen erneut senden duerfen. 01.10.26: Die Zeit seit dem letzten Takt war
     versteckt/eingefroren und zaehlt nicht (lastTick neu, Video-Kontingent verschoben). Auch bei pageshow aus dem
     bfcache (persisted), dort feuert nicht jeder Browser zuverlaessig visibilitychange. */
  function zurueck() { pauseUeberspringen(Date.now()); sent = false; actZuletzt = Date.now(); }
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') send();
    else zurueck();
  });
  window.addEventListener('pageshow', function (e) { if (e && e.persisted) zurueck(); });
  /* focus: nur Luecken-Pruefung (zeitBuchen bucht bis 6 s normal, darueber nichts). Kein blindes lastTick-Reset,
     sonst ginge bei jedem Fensterwechsel am Desktop bis zu 1 Takt sichtbare Zeit verloren. */
  window.addEventListener('focus', function () { zeitBuchen(); });
})();

/**
 * Block 4: Cookie-Banner (v4, 26.7.26)
 *
 * Ersetzt Shopifys Standard-Banner durch einen conversion-optimierten Dialog im
 * EXAKTEN Stil des bestehenden Dialog-Systems (edelholz-widerruf-popup /
 * edelholz-beratung-popup): Overlay blur(12px) ueber rgba(0,0,0,0.4), Glas-Karte
 * 12px Radius, Buttons 8px, Montserrat, Champagne #E8E0D8, Akzent #B89464.
 * (Das grosse Discover-Panel mit 20px Radius + Pill-Button ist bewusst eine
 * andere Welt, das ist ein Panel, kein Dialog.)
 *
 * Warum ueberhaupt ein eigener Banner: Shopifys Standard gewichtet Akzeptieren
 * und Ablehnen gleich. Ohne Marketing-Zustimmung laedt der Meta-Pixel nicht, es
 * entstehen keine _fbp/_fbc-Cookies, genau die fehlen in der Attribution.
 * Zustimmung wird ueber die OFFIZIELLE Shopify-Customer-Privacy-API gesetzt.
 *
 * Behobene Fehler aus den Tests:
 *  - Beim Schliessen wurde auch das CSS entfernt, das Shopifys Banner versteckt
 *    - der poppte staendig wieder auf.
 *  - Shopifys Banner war die ersten Sekunden sichtbar, weil erst auf die
 *    Consent-API gewartet wurde. Verstecken passiert jetzt SOFORT, mit
 *    Sicherheits-Rueckfall falls die API ausbleibt.
 *  - Nicht mehr an shouldShowBanner() gekoppelt, seit der Shopify-Banner in den
 *    Einstellungen aus ist, kann das Flag umspringen und es erschiene gar kein
 *    Banner mehr (= nie wieder Zustimmung).
 */
(function () {
  if (window.__ehConsentInit) return; window.__ehConsentInit = true;
  var STORE_KEY = 'eh_consent_v1';

  /* === BANNER-TEXTE (27.09.26) - EINZIGE Stelle fuer den Wortlaut aller Varianten ===
     Variante kommt aus Block 3 (window.EdelholzBanner.variante, Theme-Setting eh_banner_variante).
     'gemeinsam' gilt fuer alle, ein Eintrag je Variante ueberschreibt einzelne Felder.
     Platzhalter in 'text': {datenschutz} = Link zur Datenschutzerklaerung, {ablehnen} = klickbares
     "ablehnen" im Fliesstext (w4/w4l, gleiche Aktion wie der Ablehnen-Link). HTML-Entities erlaubt.
     v2 = Kontrolle, Wortlaut bitte NICHT aendern (sonst ist der Vergleich hinfaellig).
     Keine Gedankenstriche im Wortlaut (29.09.26: Haken-Texte mit Doppelpunkt). */
  var BANNER_TEXTE = {
    gemeinsam: {
      eyebrow: 'Datenschutz',
      titel: 'Für ein Erlebnis nach Maß',
      einverstanden: 'Einverstanden',
      ablehnen: 'Ablehnen',
      einstellungen: 'Einstellungen',
      speichern: 'Auswahl speichern',
      datenschutzLink: 'Datenschutzerklärung',
      hakenStatistik: 'Statistik: verstehen, was gut ankommt',
      hakenMarketing: 'Marketing: passende Inhalte &amp; Angebote',
      hakenKomfort: 'Komfort: deine Einstellungen merken',
      xLabel: 'Später entscheiden',
      xLabelErneut: 'Schließen'
    },
    v2: {
      text: 'Wie unsere Möbel passen wir auch deinen Besuch an: Mit deinem Okay sehen wir, was dich interessiert, ' +
        'und zeigen dir Passendes statt Beliebiges. Details in der {datenschutz}.'
    },
    w3: {
      text: 'Wie unsere Möbel passen wir auch deinen Besuch an: Mit deinem Okay nutzen wir Cookies für Statistik ' +
        'und Werbung und zeigen dir Passendes statt Beliebiges. Mehr dazu in der {datenschutz}.'
    },
    w4: {
      text: 'Wie unsere Möbel passen wir auch deinen Besuch an: Mit deinem Okay nutzen wir Cookies für Statistik ' +
        'und Werbung. Du kannst auch {ablehnen}. Mehr dazu in der {datenschutz}.',
      ablehnenImText: 'ablehnen',
      zurueck: 'Zurück',
      linkDatenschutz: 'Datenschutz',
      linkImpressum: 'Impressum'
    },
    // w4l (29.09.26) = "w4 light": Text wie w4, kein ✕, "ablehnen" im Text hell statt Champagne,
    // untere Zeile Einstellungen · Ablehnen · Datenschutz · Impressum
    w4l: {
      text: 'Wie unsere Möbel passen wir auch deinen Besuch an: Mit deinem Okay nutzen wir Cookies für Statistik ' +
        'und Werbung. Du kannst auch {ablehnen}. Mehr dazu in der {datenschutz}.',
      ablehnenImText: 'ablehnen',
      zurueck: 'Zurück',
      linkDatenschutz: 'Datenschutz',
      linkImpressum: 'Impressum'
    }
  };
  var BANNER_VARIANTE = 'v2';
  try { var bvW = window.EdelholzBanner && window.EdelholzBanner.variante; if (BANNER_TEXTE[bvW] && bvW !== 'gemeinsam') BANNER_VARIANTE = bvW; } catch (e) {}
  function bannerTexte(v) {
    var t = {}, k, g = BANNER_TEXTE.gemeinsam, e = BANNER_TEXTE[v] || BANNER_TEXTE.v2;
    for (k in g) t[k] = g[k];
    for (k in e) t[k] = e[k];
    return t;
  }
  // Inhalt der Karte je Variante. v2 ergibt das Markup vor dem Varianten-Umbau (Test prueft das;
  // einzige Aenderung 29.09.26: Doppelpunkt statt Gedankenstrich in den Haken-Texten).
  function bannerHtml(v) {
    var T = bannerTexte(v), ohneX = v === 'w4' || v === 'w4l';
    var zeile;
    if (v === 'w4l') {
      zeile = '<div class="eh-c-row">' +
          '<button type="button" class="eh-c-link eh-c-settings">' + T.einstellungen + '</button>' +
          '<span class="eh-c-dot" aria-hidden="true">·</span>' +
          '<button type="button" class="eh-c-link eh-c-decline">' + T.ablehnen + '</button>' +
          '<span class="eh-c-dot" aria-hidden="true">·</span>' +
          '<a class="eh-c-link" href="/policies/privacy-policy">' + T.linkDatenschutz + '</a>' +
          '<span class="eh-c-dot" aria-hidden="true">·</span>' +
          '<a class="eh-c-link" href="/policies/legal-notice">' + T.linkImpressum + '</a>' +
        '</div>';
    } else if (ohneX) {
      zeile = '<div class="eh-c-row">' +
          '<button type="button" class="eh-c-link eh-c-settings">' + T.einstellungen + '</button>' +
          '<span class="eh-c-dot" aria-hidden="true">·</span>' +
          '<a class="eh-c-link" href="/policies/privacy-policy">' + T.linkDatenschutz + '</a>' +
          '<span class="eh-c-dot" aria-hidden="true">·</span>' +
          '<a class="eh-c-link" href="/policies/legal-notice">' + T.linkImpressum + '</a>' +
        '</div>';
    } else {
      zeile = '<div class="eh-c-row">' +
          '<button type="button" class="eh-c-link eh-c-decline">' + T.ablehnen + '</button>' +
          '<button type="button" class="eh-c-link eh-c-settings">' + T.einstellungen + '</button>' +
        '</div>';
    }
    var text = T.text
      .replace('{datenschutz}', '<a href="/policies/privacy-policy">' + T.datenschutzLink + '</a>')
      .replace('{ablehnen}', '<button type="button" class="eh-c-inline eh-c-decline">' + (T.ablehnenImText || T.ablehnen) + '</button>');
    return (ohneX ? '' : '<button type="button" class="eh-c-x" aria-label="' + T.xLabel + '">✕</button>') +
      '<div class="eh-c-eyebrow">' + T.eyebrow + '</div>' +
      '<h2>' + T.titel + '</h2>' +
      '<p>' + text + '</p>' +
      '<button type="button" class="eh-c-accept">' + T.einverstanden + '</button>' +
      '<div class="eh-c-panel">' +
        '<label><input type="checkbox" data-k="analytics"> ' + T.hakenStatistik + '</label>' +
        '<label><input type="checkbox" data-k="marketing"> ' + T.hakenMarketing + '</label>' +
        '<label><input type="checkbox" data-k="preferences"> ' + T.hakenKomfort + '</label>' +
        (ohneX
          ? '<div class="eh-c-panelrow"><button type="button" class="eh-c-save">' + T.speichern + '</button>' +
            '<button type="button" class="eh-c-link eh-c-back">' + T.zurueck + '</button></div>'
          : '<button type="button" class="eh-c-save">' + T.speichern + '</button>') +
      '</div>' + zeile;
  }

  function readChoice() {
    try { return JSON.parse(localStorage.getItem(STORE_KEY) || 'null'); } catch (e) { return null; }
  }
  function saveChoice(c) {
    try { localStorage.setItem(STORE_KEY, JSON.stringify({ c: c, t: Date.now() })); } catch (e) {}
  }
  function hideNativeBanner() {
    if (document.getElementById('eh-consent-hide')) return;
    var st = document.createElement('style');
    st.id = 'eh-consent-hide';
    st.textContent = '#shopify-pc__banner,.shopify-pc__banner{display:none !important;}';
    (document.head || document.documentElement).appendChild(st);
  }
  function unhideNativeBanner() {
    var st = document.getElementById('eh-consent-hide');
    if (st) st.remove();
  }
  hideNativeBanner();            // sofort, sonst blitzt Shopifys Banner auf
  var uebernommen = false;       // true, sobald wir den Consent-Fall selbst bedienen

  var tries = 0;
  function waitForApi() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (cp && typeof cp.setTrackingConsent === 'function') { start(cp); return; }
    if (++tries < 40) { setTimeout(waitForApi, 150); return; }
    // Nach ~6s keine API: wir koennen keinen gueltigen Consent schreiben,
    // also Shopifys eigenen Banner wieder freigeben.
    if (!uebernommen) unhideNativeBanner();
  }

  function start(cp) {
    // Frueher entschieden? Wahl still nachreichen (falls der erste Save nicht
    // griff), Banner bleibt versteckt, fertig, nie wieder fragen.
    var prev = readChoice();
    if (prev && prev.c) {
      uebernommen = true;
      try { cp.setTrackingConsent(prev.c, function () {}); } catch (e) {}
      return;
    }
    // "Spaeter entscheiden" (X) gilt fuer die laufende Sitzung
    try { if (sessionStorage.getItem('eh_consent_later')) { uebernommen = true; return; } } catch (e) {}

    // Massgeblich: gilt hier die DSGVO und fehlt die Entscheidung noch?
    var brauchtFrage = true;
    try {
      var c = cp.currentVisitorConsent ? cp.currentVisitorConsent() : null;
      var entschieden = c && ['marketing', 'analytics', 'preferences'].some(function (k) {
        return c[k] === 'yes' || c[k] === 'no';
      });
      var reguliert = cp.getRegulation ? cp.getRegulation() !== null : true;
      if (entschieden || !reguliert) brauchtFrage = false;
    } catch (e) { /* im Zweifel fragen */ }
    if (!brauchtFrage) { uebernommen = true; return; }

    uebernommen = true;
    zeigeDialog(cp, null);
  }

  // Baut den Dialog auf. vorwahl = frueher gespeicherte Wahl (beim erneuten
  // Oeffnen ueber "Cookie-Einstellungen" im Footer), sonst null.
  function zeigeDialog(cp, vorwahl) {
    if (document.querySelector('.eh-consent-ov')) return;

    // Werte 1:1 aus dem bestehenden Dialog-System des Themes
    var css = [
      '.eh-consent-ov{position:fixed;inset:0;z-index:99999;display:flex;align-items:center;justify-content:center;',
      '  background:rgba(0,0,0,0.4);backdrop-filter:blur(12px);-webkit-backdrop-filter:blur(12px);',
      '  opacity:0;visibility:hidden;transition:opacity .3s ease,visibility .3s ease;padding:16px;',
      "  font-family:'Montserrat',sans-serif;-webkit-font-smoothing:antialiased;}",
      '.eh-consent-ov.is-open{opacity:1;visibility:visible;}',
      '.eh-consent-ov *{box-sizing:border-box;margin:0;padding:0;}',
      '.eh-consent{position:relative;width:100%;max-width:520px;max-height:92vh;background:rgba(26,26,26,0.9);',
      '  backdrop-filter:blur(20px) saturate(1.2);-webkit-backdrop-filter:blur(20px) saturate(1.2);',
      '  border:1px solid rgba(255,255,255,0.08);border-radius:12px;box-shadow:0 24px 80px rgba(0,0,0,0.4);',
      '  overflow-y:auto;transform:translateY(40px);transition:transform .35s cubic-bezier(0.16,1,0.3,1);padding:34px 30px;}',
      '.eh-consent-ov.is-open .eh-consent{transform:translateY(0);}',
      '.eh-consent .eh-c-x{position:absolute;top:14px;right:14px;width:38px;height:38px;',
      '  border:1.5px solid rgba(255,255,255,0.25);background:rgba(255,255,255,0.08);font-size:20px;line-height:35px;',
      "  text-align:center;color:#E8E0D8;cursor:pointer;border-radius:50%;transition:background .2s,border-color .2s;font-family:'Montserrat',sans-serif;}",
      '.eh-consent .eh-c-x:hover{background:rgba(255,255,255,0.15);border-color:rgba(255,255,255,0.4);}',
      '.eh-consent .eh-c-eyebrow{font-size:12px;letter-spacing:0.18em;text-transform:uppercase;',
      '  color:var(--eh-accent,#B89464);font-weight:500;margin-bottom:10px;}',
      '.eh-consent h2{font-size:21px;font-weight:600;color:#E8E0D8;margin-bottom:8px;letter-spacing:0.01em;}',
      '.eh-consent p{font-size:13.5px;font-weight:300;color:rgba(255,255,255,0.5);margin-bottom:24px;line-height:1.55;}',
      '.eh-consent p a{color:var(--eh-accent,#B89464);text-decoration:underline;}',
      '.eh-consent .eh-c-accept{width:100%;background:var(--eh-accent,#B89464);color:#fff;border:none;',
      "  font-family:'Montserrat',sans-serif;font-weight:600;font-size:14px;padding:14px;border-radius:8px;",
      '  cursor:pointer;transition:transform .1s,opacity .2s;}',
      '.eh-consent .eh-c-accept:active{transform:scale(0.98);}',
      '.eh-consent .eh-c-row{display:flex;justify-content:center;gap:26px;margin-top:16px;}',
      ".eh-consent .eh-c-link{background:none;border:0;padding:4px;color:rgba(255,255,255,0.45);font-size:12.5px;",
      "  cursor:pointer;text-decoration:underline;font-family:'Montserrat',sans-serif;font-weight:300;transition:color .2s;}",
      '.eh-consent .eh-c-link:hover{color:rgba(255,255,255,0.75);}',
      '.eh-consent .eh-c-panel{display:none;margin:20px 0 4px;border-top:1px solid rgba(255,255,255,0.08);padding-top:18px;}',
      '.eh-consent .eh-c-panel.eh-open{display:block;}',
      '.eh-consent label{display:flex;align-items:flex-start;gap:10px;font-size:12.5px;font-weight:400;',
      '  color:rgba(255,255,255,0.6);line-height:1.4;margin:0 0 12px;cursor:pointer;}',
      '.eh-consent input[type=checkbox]{width:18px;height:18px;accent-color:var(--eh-accent,#B89464);flex-shrink:0;margin-top:1px;}',
      '.eh-consent .eh-c-save{background:none;border:2px solid rgba(255,255,255,0.12);',
      "  font-family:'Montserrat',sans-serif;font-weight:500;font-size:13px;color:var(--eh-accent,#B89464);",
      '  padding:11px 24px;border-radius:8px;cursor:pointer;transition:all .2s;margin-top:4px;}',
      '.eh-consent .eh-c-save:hover{border-color:var(--eh-accent,#B89464);}',
      '@media (max-width:560px){.eh-consent-ov{padding:0;align-items:flex-end;}',
      '  .eh-consent{max-width:100%;max-height:94vh;border-radius:16px 16px 0 0;padding:30px 24px 24px;}}',
      /* 27.09.26: nur Varianten w4/w4l (Klasse eh-consent--w4), v2/w3 bleiben pixelgleich */
      '.eh-consent--w4 p .eh-c-inline{display:inline-block;min-height:24px;line-height:inherit;padding:2px;margin:-2px;',
      "  background:none;border:0;font:inherit;color:var(--eh-accent,#B89464);text-decoration:underline;cursor:pointer;vertical-align:baseline;}",
      '.eh-consent--w4 .eh-c-row{gap:6px;align-items:center;flex-wrap:wrap;}',
      '.eh-consent--w4 a.eh-c-link{display:inline-block;}',
      '.eh-consent--w4 .eh-c-dot{color:rgba(255,255,255,0.3);font-size:12.5px;}',
      '.eh-consent--w4 .eh-c-link{min-height:24px;}',
      '.eh-consent--w4 .eh-c-panelrow{display:flex;align-items:center;gap:18px;flex-wrap:wrap;margin-top:4px;}',
      '.eh-consent--w4 .eh-c-panelrow .eh-c-save{margin-top:0;}',
      '.eh-consent--w4 button:focus-visible,.eh-consent--w4 a:focus-visible,.eh-consent--w4 input:focus-visible{',
      '  outline:2px solid var(--eh-accent,#B89464);outline-offset:2px;border-radius:4px;}',
      /* 29.09.26: w4l traegt zusaetzlich eh-consent--w4 (erbt alles oben), hier nur die Tippflaechen >= 44 px.
         Im Fliesstext bleibt die Zeilenhoehe, die Flaeche kommt von einem unsichtbaren ::after (44 px hoch). */
      '.eh-consent--w4l p .eh-c-inline,.eh-consent--w4l p a{position:relative;}',
      ".eh-consent--w4l p .eh-c-inline::after,.eh-consent--w4l p a::after{content:'';position:absolute;left:-4px;right:-4px;top:50%;height:44px;margin-top:-22px;}",
      '.eh-consent--w4l .eh-c-accept{min-height:48px;}',
      '.eh-consent--w4l p .eh-c-inline{color:#E8E0D8;}',
      '.eh-consent--w4l .eh-c-row{gap:0;margin-top:10px;}',
      '.eh-consent--w4l .eh-c-link,.eh-consent--w4l a.eh-c-link{display:inline-flex;align-items:center;justify-content:center;min-height:44px;padding:0 4px;font-size:12px;}',
      '.eh-consent--w4l .eh-c-dot{font-size:12px;}',
      /* 4 Links passen ab 390 px in eine Zeile, schmaler: 2 x 2 zentriert statt ungleichmaessigem Umbruch */
      '@media (max-width:380px){.eh-consent--w4l .eh-c-row{display:grid;grid-template-columns:repeat(2,auto);justify-content:center;column-gap:8px;}',
      '  .eh-consent--w4l .eh-c-dot{display:none;}}',
      '.eh-consent--w4l label{min-height:44px;align-items:center;margin:0 0 2px;}',
      '.eh-consent--w4l input[type=checkbox]{margin-top:0;}',
      '.eh-consent--w4l .eh-c-save{min-height:44px;}',
      '.eh-consent--w4l .eh-c-panelrow{gap:8px;}'
    ].join('\n');

    var style = document.getElementById('eh-consent-css');
    if (!style) { style = document.createElement('style'); style.id = 'eh-consent-css'; style.textContent = css; }

    var ov = document.createElement('div');
    ov.className = 'eh-consent-ov';
    var box = document.createElement('div');
    box.className = 'eh-consent';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-label', 'Cookie-Einstellungen');
    ov.appendChild(box);
    if (BANNER_VARIANTE === 'w4l') box.className += ' eh-consent--w4';  // w4l = w4-Grundlage + eigene Regeln
    if (BANNER_VARIANTE !== 'v2') box.className += ' eh-consent--' + BANNER_VARIANTE;
    box.innerHTML = bannerHtml(BANNER_VARIANTE);

    if (vorwahl) {
      try {
        Array.prototype.forEach.call(box.querySelectorAll('input[data-k]'), function (i) {
          i.checked = vorwahl[i.getAttribute('data-k')] === true;
        });
        box.querySelector('.eh-c-panel').classList.add('eh-open');
        var xErneut = box.querySelector('.eh-c-x');
        if (xErneut) xErneut.setAttribute('aria-label', bannerTexte(BANNER_VARIANTE).xLabelErneut);
      } catch (e) {}
    }

    function closeBox() {
      try {
        if (escHandler) document.removeEventListener('keydown', escHandler, true);
        ov.classList.remove('is-open');
        setTimeout(function () { ov.remove(); }, 400);
        // style + eh-consent-hide bleiben bewusst stehen, deren Entfernung liess
        // Shopifys Banner nach dem Klick wieder aufpoppen.
      } catch (e) {}
    }
    function give(consent) {
      saveChoice(consent);
      try { cp.setTrackingConsent(consent, function () {}); } catch (e) {}
      closeBox();
    }

    var xBtn = box.querySelector('.eh-c-x');   // w4/w4l haben kein ✕
    if (xBtn) xBtn.addEventListener('click', function () {
      if (!vorwahl) { try { sessionStorage.setItem('eh_consent_later', '1'); } catch (e) {} }
      closeBox();
    });
    box.querySelector('.eh-c-accept').addEventListener('click', function () {
      give({ analytics: true, marketing: true, preferences: true, sale_of_data: true });
    });
    // v2/w3: Link "Ablehnen", w4: "ablehnen" im Fliesstext, w4l: beides - immer gleiche Aktion
    Array.prototype.forEach.call(box.querySelectorAll('.eh-c-decline'), function (b) {
      b.addEventListener('click', function () {
        give({ analytics: false, marketing: false, preferences: false, sale_of_data: false });
      });
    });
    box.querySelector('.eh-c-settings').addEventListener('click', function () {
      box.querySelector('.eh-c-panel').classList.toggle('eh-open');
    });
    box.querySelector('.eh-c-save').addEventListener('click', function () {
      var c = { analytics: false, marketing: false, preferences: false, sale_of_data: false };
      Array.prototype.forEach.call(box.querySelectorAll('input[data-k]'), function (i) {
        c[i.getAttribute('data-k')] = !!i.checked;
        if (i.getAttribute('data-k') === 'marketing') c.sale_of_data = !!i.checked;
      });
      give(c);
    });
    // w4/w4l (ohne ✕): "Zurueck" klappt die Einstellungen zu; beim erneuten Oeffnen ueber den Footer schliesst es
    // den Dialog ohne Aenderung (wie dort das ✕), ebenso Escape. Nie eine Zustimmung.
    var escHandler = null;
    var backBtn = box.querySelector('.eh-c-back');
    if (backBtn) backBtn.addEventListener('click', function () {
      if (vorwahl) { closeBox(); return; }
      box.querySelector('.eh-c-panel').classList.remove('eh-open');
      try { box.querySelector('.eh-c-settings').focus(); } catch (e) {}
    });
    if (vorwahl && !xBtn) {
      escHandler = function (e) { if (e && (e.key === 'Escape' || e.key === 'Esc')) closeBox(); };
      document.addEventListener('keydown', escHandler, true);
    }

    function mount() {
      if (!style.parentNode) document.head.appendChild(style);
      document.body.appendChild(ov);
      // kurz warten, dann einblenden, der Hero soll zuerst stehen
      setTimeout(function () { ov.classList.add('is-open'); }, 500);
    }
    if (document.body) mount();
    else document.addEventListener('DOMContentLoaded', mount);
  }

  // Erneut oeffnen (Footer-Link "Cookie-Einstellungen", Datenschutzerklaerung):
  // Besucher koennen ihre Auswahl aendern oder widerrufen. Ohne Consent-API
  // (z. B. Blocker) geben wir Shopifys eigenen Banner frei.
  function oeffneBanner() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (!cp || typeof cp.setTrackingConsent !== 'function') { unhideNativeBanner(); return false; }
    var prev = readChoice();
    zeigeDialog(cp, (prev && prev.c) || { analytics: false, marketing: false, preferences: false });
    var ov = document.querySelector('.eh-consent-ov');
    if (ov && !ov.classList.contains('is-open')) setTimeout(function () { ov.classList.add('is-open'); }, 0);
    return true;
  }
  window.edelholzOpenCookieBanner = oeffneBanner;

  document.addEventListener('click', function (ev) {
    try {
      var t = ev.target && ev.target.closest && ev.target.closest('[data-eh-cookie-settings], a[href="#cookie-einstellungen"]');
      if (!t) return;
      ev.preventDefault();
      oeffneBanner();
    } catch (e) {}
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', waitForApi);
  else waitForApi();
})();

/**
 * Block 5 - Warenkorb-Attribute _eh_vid / _eh_sid (29.09.26, Ads-Session, Philipp-OK)
 * Zweck: Shop-Kaeufe ohne Formular derselben vid zuordnen wie der Beacon. Der Server liest
 * order.note_attributes (_eh_vid, _eh_sid). Unterstrich-Praefix = im Checkout unsichtbar.
 * Laeuft unabhaengig vom Consent (eigene vid, Entscheidung Philipp).
 * Regeln:
 *  - Leerer Warenkorb (item_count 0): nichts. Werte stimmen schon: nichts.
 *  - Stand kommt ohne Request aus Liquid (window.themeVariables.ehWarenkorb, snippets/js-variables.liquid),
 *    aus cart:change (detail.cart) oder aus Antworten von /cart/change|update|clear. Nur nach /cart/add
 *    (Antwort ohne Attribute) wird einmal /cart.js gelesen.
 *  - Gesetzt wird per POST /cart/update.js mit NUR { attributes: {_eh_vid, _eh_sid} }: Shopify fuehrt die
 *    Attribute zusammen, andere Attribute, note, Mengen, Properties und Rabatte bleiben unberuehrt.
 *  - Erst wenn keine fremde Warenkorb-Aenderung (fetch POST /cart/add|change|update|clear) mehr laeuft
 *    (kurz entprellt), nie parallel zu einem Add-to-Cart.
 *  - Checkout-Klick (Formular an /cart mit Button name="checkout"): versteckte Felder
 *    attributes[_eh_vid]/attributes[_eh_sid] ins Formular, Shopify speichert sie mit dem Absenden.
 *    Kein Warten, kein preventDefault.
 *  - Fehler werden geschluckt, die Antworten fremder Requests gehen unveraendert an den Aufrufer.
 */
(function () {
  if (window.__ehCartAttrInit) return; window.__ehCartAttrInit = true;
  var ROOT = '/';
  try { ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; } catch (e) {}
  var WARTEN_MS = 300;
  var bekannt = null;   // { n, vid, sid, token } letzter bekannter Server-Stand, null = unbekannt
  var laufend = 0;      // fremde Warenkorb-Aenderungen im Flug
  var timer = 0, sendet = false, gesetztFuer = '';
  var _f = window.fetch;

  function gueltig(x) { x = String(x == null ? '' : x); return /^[A-Za-z0-9]{1,40}$/.test(x) ? x : ''; }
  function ids() {
    var a = {};
    try { a = (window.EdelholzAttribution && window.EdelholzAttribution.get()) || {}; } catch (e) {}
    return { vid: gueltig(a.vid), sid: gueltig(a.sid) };
  }
  function merken(cart) {
    if (!cart || typeof cart !== 'object' || typeof cart.item_count !== 'number') return false;
    var at = (cart.attributes && typeof cart.attributes === 'object') ? cart.attributes : {};
    bekannt = { n: cart.item_count, vid: String(at._eh_vid || ''), sid: String(at._eh_sid || ''), token: String(cart.token || '') };
    return true;
  }
  function noetig() {
    var i = ids();
    if (!bekannt || !(bekannt.n > 0) || !i.vid) return false;
    if (bekannt.vid === i.vid && (!i.sid || bekannt.sid === i.sid)) return false;
    // veraltetes cart-Objekt (vor unserem eigenen Update gelesen) desselben Warenkorbs: nicht doppelt senden
    if (bekannt.token && gesetztFuer === bekannt.token + '|' + i.vid + '|' + i.sid) return false;
    return true;
  }
  function setzen() {
    var i = ids();
    if (!i.vid || sendet || !_f) return;
    sendet = true;
    var attrs = { _eh_vid: i.vid };
    if (i.sid) attrs._eh_sid = i.sid;
    try {
      _f.call(window, ROOT + 'cart/update.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: attrs })
      }).then(function (r) { return r && r.ok ? r.json() : null; })
        .then(function (c) { if (merken(c) && bekannt.token) gesetztFuer = bekannt.token + '|' + i.vid + '|' + i.sid; })
        .catch(function () {})
        .then(function () { sendet = false; });
    } catch (e) { sendet = false; }
  }
  function pruefen() {
    timer = 0;
    try {
      if (laufend > 0 || sendet) { planen(); return; }
      if (bekannt) { if (noetig()) setzen(); return; }
      if (!_f) return;
      // Stand unbekannt (nach /cart/add): einmal lesen
      _f.call(window, ROOT + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r && r.ok ? r.json() : null; })
        .then(function (c) {
          if (!merken(c)) return;
          if (laufend > 0) { planen(); return; } // inzwischen neue Aenderung: danach erneut
          if (noetig()) setzen();
        })
        .catch(function () {});
    } catch (e) {}
  }
  function planen() {
    try { if (timer) clearTimeout(timer); timer = setTimeout(pruefen, WARTEN_MS); } catch (e) {}
  }

  // 1) Seitenaufruf: Stand aus Liquid, kein Request, solange leer oder schon richtig
  try {
    var w = window.themeVariables && window.themeVariables.ehWarenkorb;
    if (w && typeof w.n === 'number') {
      bekannt = { n: w.n, vid: String(w.vid || ''), sid: String(w.sid || ''), token: '' };
      if (noetig()) planen();
    }
  } catch (e) {}

  // 2) Theme-Ereignis: Prestige (Kaufbox, Drawer-Mengen), Zuschlag-Kopplung liefern das ganze cart-Objekt
  try {
    document.addEventListener('cart:change', function (e) {
      try { if (merken(e && e.detail && e.detail.cart) && noetig()) planen(); } catch (x) {}
    });
  } catch (e) {}

  // 3) fetch-Huelle: fremde Warenkorb-Aenderungen zaehlen, nach Abschluss pruefen
  //    (Konfigurator, Minikonfigurator, Add-on-Seiten, Buy-Buttons legen per fetch('/cart/add.js') an)
  try {
    if (_f) {
      window.fetch = function (input, init) {
        var art = '';
        try {
          var u = typeof input === 'string' ? input : String((input && (input.url || input.href)) || '');
          var m = String((init && init.method) || (input && typeof input === 'object' && input.method) || 'GET').toUpperCase();
          var t = m === 'POST' ? /\/cart\/(add|change|update|clear)(?:\.js)?(?:[?#]|$)/.exec(u.split('#')[0]) : null;
          if (t) art = t[1];
        } catch (x) { art = ''; }
        var p = _f.apply(this, arguments);
        if (!art) return p;
        laufend++;
        try {
          p.then(function (r) {
            laufend = Math.max(0, laufend - 1);
            try {
              if (!r || !r.ok || art === 'add' || typeof r.clone !== 'function') { bekannt = null; planen(); return; }
              // change/update/clear antworten mit dem ganzen Warenkorb (inkl. attributes)
              r.clone().json().then(function (c) { if (!merken(c)) bekannt = null; planen(); }, function () { bekannt = null; planen(); });
            } catch (x) { bekannt = null; planen(); }
          }, function () { laufend = Math.max(0, laufend - 1); bekannt = null; planen(); });
        } catch (x) { laufend = Math.max(0, laufend - 1); }
        return p;
      };
    }
  } catch (e) {}

  // 4) Checkout: Werte als versteckte Felder mitschicken (kein Warten, kein Abfangen)
  function feld(form, name, wert) {
    var key = 'attributes[' + name + ']';
    var el = null;
    try {
      var alle = form.querySelectorAll('input[type="hidden"]');
      for (var k = 0; k < alle.length; k++) { if (alle[k].getAttribute('name') === key) { el = alle[k]; break; } }
    } catch (e) {}
    if (!el) {
      el = document.createElement('input');
      el.setAttribute('type', 'hidden');
      el.setAttribute('name', key);
      form.appendChild(el);
    }
    el.value = wert; el.setAttribute('value', wert);
  }
  try {
    document.addEventListener('submit', function (e) {
      try {
        var f = e && e.target;
        if (!f || !f.getAttribute || String(f.getAttribute('method') || '').toUpperCase() !== 'POST') return;
        var act = String(f.getAttribute('action') || '').split(/[?#]/)[0];
        if (!/^(?:https?:\/\/[^\/]+)?\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?cart\/?$/i.test(act)) return;
        var sub = e.submitter;
        var zurKasse = sub ? (sub.getAttribute && sub.getAttribute('name')) === 'checkout' : !!(f.querySelector && f.querySelector('[name="checkout"]'));
        if (!zurKasse) return;
        var i = ids();
        if (!i.vid) return;
        feld(f, '_eh_vid', i.vid);
        if (i.sid) feld(f, '_eh_sid', i.sid);
      } catch (x) {}
    }, true);
  } catch (e) {}
})();
